import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator'; 
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import * as XLSX from 'xlsx';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { NewauditComponent } from '../../newaudit/newaudit.component';

// PinnedMessage interface definition
export interface PinnedMessage {
  messageId: string;
  routeGuid: string;
  routeName?: string;
  pinName?: string;
  reason?: string;
  messageData?: any;
  pinnedDate?: Date;
}

import * as Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import Drilldown from 'highcharts/modules/drilldown';
More(Highcharts);
Drilldown(Highcharts);
// Load the exporting module.
import Data from 'highcharts/modules/data';
import Exporting from 'highcharts/modules/exporting';
import { VarulesComponent } from 'src/app/varules/varules.component';
import { forEach } from 'jszip';
import { error } from 'selenium-webdriver';
import { mergeMap, map, catchError, takeUntil, debounceTime, distinctUntilChanged, switchMap, startWith } from 'rxjs/operators';
import { forkJoin, of, Subject, Subscription, timer, firstValueFrom } from 'rxjs';
import { FtpfilesComponent } from 'src/app/ftpfiles/ftpfiles.component';
import { V, X } from '@angular/cdk/keycodes';
import { XmlmappingsComponent } from 'src/app/xmlmappings/xmlmappings.component';
import { TryitoutComponent } from 'src/app/tryitout/tryitout.component';
import { Routeversion1Component } from 'src/app/routeversion1/routeversion1.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RuleConfigComponentComponent } from 'src/app/rule-config-component/rule-config-component.component';
import { RuleEngineService } from 'src/app/services/rule-engine.service';
import { Hl7viewerComponent } from 'src/app/hl7viewer/hl7viewer.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/confirm-dialog/confirm-dialog.component';
import { InterfacemappingComponent } from '../../interfacemapping/interfacemapping.component';
import { InterfaceCompareComponent } from '../../interface-compare/interface-compare.component';

// Initialize exporting module.
Exporting(Highcharts);
// Initialize Data module.
Data(Highcharts);
declare var $;
declare const copyToClipboard: any;


@Component({
  selector: 'app-interface',
  templateUrl: './interface.component.html',
  styleUrls: ['./interface.component.scss']
})
export class InterfaceComponent implements OnInit, OnDestroy {

  public reactiveFormroute: FormGroup;
  public reactiveFormpa: FormGroup;
  public reactiveFormmsgtype: FormGroup;
  public reactiveFormdirection: FormGroup;
  public reactiveFormvendor: FormGroup
  public reactiveFormentity: FormGroup
  public reactiveFormse: FormGroup
  reactiveFormProject: FormGroup
  public reactiveFormde: FormGroup
  public reactivefloderpath: FormGroup
  public showexportbutton: boolean = false;

  keywordsearch = 'displayname';
  keywordsearchdir = 'name'
  selectedIndexTab = 0;
  keywordsearchvendar = "name";
  keywordsearcha = "LocationName";
  keywordsearchProj = "projectName";
  RouteNameListPipeline: any[] = [];
  GlobalSearchDisplayname: any[] = [];
  isLoadingResult: boolean
  notfounddata: boolean
  isadvancefilter: boolean

  interfacedetails = {}
  Highcharts: typeof Highcharts = Highcharts;
  selectedRoutGUID: any;
  selectedRouteName: any;
  category: any;
  //Details
  showSourceTarget: boolean=true;
  selectedSeqName: string;

  //datavalidation
  InterfaceValidationHistory: any = [];
  InterfaceMessageDataByMessageid: any = [];
  dataSources: any[];
  displayedColumns: string[] = ['pipeline', 'generatedby', 'generatedon', 'status'];
  currentItem = 'Televi;sion';
  validatedDataResponse: any;
  callingComponent: any = '';
  maxItemsToShow = 4;
  tripfilter = {
    PipelineName: '',
    Fromdate: '',
    Todate: '',
    Generated_By: '',
    Generated_On: '',
    Status: ''
  }
  cardfilter = {
    Accession: '',
    Order: '',
    DateofBirth: '',
    PatientName: '',
    MessageId: ''
  }

  //datavalidation
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  @ViewChild('ValidationContent', { static: false }) ValidationContent: any;

  // @ViewChild('reValidationPopup', { static: false }) reValidationPopup: any;

  [x: string]: any;
  config = {
    displayKey: 'lookupvalue', //if objects array passed which key to be displayed defaults to description
    search: true,
    height: '50%',
    width: '80%',
    // width: '1202'px,
    /* height: 507px; */
  }
  showInterfaceData: boolean = false;
  filteredInterfaceRevalidationData: any = [];
  searchtextData: string = '';
  selectedFromDate: any;
  pipelineGUID: any;
  pipelineName: any;
  backupPipelineName: any;
  id: any;
  Pipeline: any;
  PipelineGUID: any;
  backupPipelineGUID: any;
  backupPipeline: any;
  piplineguid: any;
  responseLength: any;
  selectedToDate: any;
  today: any = new Date();
  pipeline: string;
  generatedby: string;
  Generatedon: number;
  Status: string;
  statusMessage: string;
  reponseList: any = [];
  reponseListBackup: any = [];
  Validationcomponent: any = {};
  validationItem: any = {};
  FilertData = [];
  interfacePipelineDisplayname: any = '';
  backupInterfacePipelineDisplayname
  inputDataInModalComponent: any = [];
  selectedCardIndex: number = 0;
  searchData: any;
  modalReference = null;

  messagereprocessdata: any = [];
  messagereprocess: any = [];
  failedMessageNote :string ='';
  successmsglist:any[]=[];
  selectedrouteId: string = ""
  selectedrouteDisplayName: string
  selectedGS: string
  failurereason: any[] = [];
  isdate: boolean
  reason: string = ''
  count: string = ''
  fromdatepop: string = ''
  todatepop: string = ''
  selecteddate: any
  failurereasonBackup: any
  fromdate: any = ""
  todate: any = ""
  status: boolean = true
  global: boolean= true
  direction: any = "Inbound"
  interfacelist: any[] = []
  issearched: boolean
  directionCtrl = new FormControl("");
  response: any
  chartOptions = {}
  pipeLineDetails = {}
  isRuleEngine = false;
  ruleConfigVersionsList: any[] = [];
  isselect: string = ''
  sourcedeploy: string = ''
  targetdeploy: string = ''
  sourcetype: string = ''
  targettype: string = ''
  sequence: any[] = []
  connseqdatalist: any[] = []
  mode: string = ''
  base64data: string
  ishide: boolean = true
  isLoadingpa: boolean = false;
  ProcessorAgentNameList: any[] = []
  ProcessorList: any[] = []
  isChecked: boolean
  selectedProcessorAgentguid: string = ''
  selectedProcessorAgentName: string = ''
  isLoadingmessagetype: boolean = false;
  messageTypeAllList: any = [];
  messageTypeList: any = [];
  directionlist: any[] = [];

  isLoadingVendorName: Boolean = false;
  Vendornamelist: any[] = []
  VendornameBackuplist: any[] = []
  vendorname: string = ''
  vendorid: string = ''
  isLoadingvendor: boolean
  selectedEntityguid: string
  selectedEntityName: string
  isLoadingentity: boolean
  EntityNameList: any[] = []
  selectedSourceEntityguid: string = ''
  selectedSourceEntityName: string = ''
  selectedSourcedeploymentkey: string = ''
  selectedSourceAssociateAaccountids: string = ''
  selectedSourceEntitytype: string = "";
  isLoadingse: boolean
  SourceEntityNameList: any[] = []
  selectedTargetEntityguid: string = ''
  selectedTargetEntityName: string = ''
  sourceIsTestOrganization: string = '';
  destinationIsTestOrganization: string = '';
  private testOrgFlagsLoadedForSourceGuid = '';
  private testOrgFlagsLoadedForDestGuid = '';
  selectedtargetedeploymentkey: string = ''
  selectedEntitydeploymentkey: string = ''
  selectedEntitytype: string = ''
  selectedtargetAssociateAaccountids: string = ''
  selectedTargetEntitytype: string = "";
  isLoadingde: boolean
  TargetEntityNameList: any[] = []
  selectedprojId: string = ''
  selectedProjName: string = ''
  pagenumber: any = 1
  // Cards built from HubMessage/GetSearchDetails for pinned messages
  pinnedMessageCards: any[] = [];
  totalrecords: number
  dateoption: string = "Modified"
  isLoadingProjects: boolean
  notfoundProj: boolean
  ProjectNames = []
  pendingfilecount: number = 0
  pendingfiledate: any = ''
  DiagnosticList: any[] = []
  showdiagnostics: boolean
  seqdataarr: any[] = []
  issuccessmsgpop:string=''
  jobid:any[]=[];
  sendToChild1:any
  sendToChild2:string=''
  isviewpassword: boolean
  event: any
  PageSize = 15;
  isopenpopup:boolean=true;
  
  // Pinned Messages
  pinnedMessages: PinnedMessage[] = [];
  isLoadingPinnedMessages: boolean = false;
  /** Per pipeline/route-definition id: pinned message count from api/PinMessage/Getpinnedmessages */
  pinnedMessageCountByRouteId: Record<string, number> = {};
  reactiveFormuser:FormGroup;
  Templatearray: any[];
  public dataToModal: any;
  fileUploadFTP:boolean;
  enableAccessionSearch:boolean;
  isftpuser:boolean;
  selectedusername:string=''
  userlist:any[]=[];
  userlistbackup:any[]=[];
  selecteduserid:string='';
  mappedXml: string = '';
  isLoadinguser:boolean;
  interfacesearchvalue: any;
  //isDropdownSelection: boolean = false;
  isLoadingGS: boolean
  CallBySearchBar: boolean=false;
  notFound: string = 'Not Found'; 
  IsValidationAck: string = '';
  showPinned: boolean = false;
  expandedIds = new Set<string>();
  /** First interface pinned for Beyond Compare?style comparison. */
  /** First interface pinned for Beyond Compare–style comparison. */
  compareSourceInterface: any = null;

  constructor(
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private _fb: FormBuilder,
    public service: CommonService,
    private activeModal: NgbActiveModal,
    private router: Router,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private tabChangeService: TabChangeService,
    private _ruleEngineService: RuleEngineService
  ) {
    this.reactiveFormroute = this._fb.group({ routename: '' });
    this.reactiveFormpa = _fb.group({ paname: '' });
    this.reactiveFormmsgtype = this._fb.group({ msgname: '' });
    this.reactiveFormdirection = this._fb.group({ direction: '' });
    this.reactiveFormvendor = _fb.group({ vendorname: '' });

    if (this.vendorname) {
      this.reactiveFormvendor.patchValue({
        vendorname: this.vendorname
      })
    }
    this.reactiveFormentity = _fb.group({ entityname: '' });
    this.reactiveFormse = _fb.group({ sename: '' });
    this.reactiveFormde = _fb.group({ dename: '' });
    this.reactiveFormProject = _fb.group({ projectName: '' });
    this.reactiveFormuser = _fb.group({ user: '' });
    this.reactivefloderpath = _fb.group({ folderPath: '' });
  }
  todaydate: any
  pagerolepermisions:any=[];
  pipelineObj: any;
  keywordsearchuser = 'UserName';
  private destroy$ = new Subject<void>();
  private venlistinterface:Subscription=new Subscription();
  
  // Modal tab management
  private tabChangeSubscription: Subscription;
  private componentName = 'interface';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  private modalRefsTracked: Array<{ ref: any, windowClass: string }> = [];

  private trackModalRef(modalRef: any, windowClass: string = '') {
    this.currentModalRefs.push(modalRef);
    this.modalRefsTracked.push({ ref: modalRef, windowClass });
  }

  private untrackModalRef(modalRef: any) {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    this.modalRefsTracked = this.modalRefsTracked.filter(m => m.ref !== modalRef);
  }
  
ngOnDestroy() {
  // Close all open modals when component is destroyed
  if (this.currentModalRefs && this.currentModalRefs.length > 0) {
    this.currentModalRefs.forEach(modalRef => {
      if (modalRef) {
        try {
          modalRef.close();
        } catch (e) {
          // Modal might already be closed, ignore error
        }
      }
    });
    this.currentModalRefs = [];
    this.modalRefsTracked = [];
  }
  
  sessionStorage.setItem("VendorData",'');
  this.selectedrouteId='';
  this.global=true;
  this.reactiveFormroute.controls['routename'].setValue(''); // Update input field
        this.selectedrouteDisplayName = '';
        sessionStorage.setItem("RouteData",'');
  this.destroy$.next();
  this.destroy$.complete();
  if (this.tabChangeSubscription) {
    this.tabChangeSubscription.unsubscribe();
  }
  if (this.venlistinterface) {
    this.venlistinterface.unsubscribe();
  }
}
  ngOnInit() {
    this.setupSearch();
    this.service.timezoneChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.interfacelist?.length) {
          this.getpipelinelist(this.issearched, true);
        }
      });
    this.showSourceTarget = true;
    const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'interface').MenuId;
    const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
    actionitems.forEach(element => {
      this.pagerolepermisions[element.MenuName] = true;
     // //console.log(this.pagerolepermisions)
    });
    this.showdiagnostics = false;
    this.isselect = ''
    this.issearched = false
    this.ishide = true
    this.todaydate =this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.getMessagetypelist('msgtype');
    this.directionlist = [
      { 'name': 'Inbound' }, { 'name': 'Outbound' }
    ]
    this.getVendornames();
    this.getuserdetails();
    if(sessionStorage.getItem("VendorData")!='' && sessionStorage.getItem("VendorData")!=null){
      this.reset();
      let obj=JSON.parse(sessionStorage.getItem("VendorData"));
            this.global=false;
            this.isadvancefilter=true;
            this.vendorname=obj.vendorname;
            this.vendorid=obj.vendorid;
            this.reactiveFormvendor.patchValue({
              vendorname: this.vendorname
            })
            this.getpipelinelist(true,false);
            sessionStorage.setItem("VendorData",'');
    }
    if(sessionStorage.getItem("RouteData")!='' && sessionStorage.getItem("RouteData")!=null){
      this.reset();
      let data=JSON.parse(sessionStorage.getItem("RouteData"));
      this.selectedrouteId=data.RouteGuid;
      this.reactiveFormroute.controls['routename'].setValue(data.RouteName); // Update input field
      this.selectedrouteDisplayName = data.RouteName;
      this.global=false;
      sessionStorage.setItem("RouteData",'');
      this.getpipelinelist(true,false);
    }
    
    this.service.case360interface_2$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data:any)=>{
      if(data!=undefined && data!=null){
        this.reset();
        data=JSON.parse(data);
        this.selectedrouteId=data.RouteGuid;
        this.reactiveFormroute.controls['routename'].setValue(data.RouteName); // Update input field
        this.selectedrouteDisplayName = data.RouteName;
        this.global=false;
        sessionStorage.setItem("RouteData",'');
        this.getpipelinelist(true,false);
      }
    });
      this.venlistinterface.add(this.service.vendorinterface$
        .subscribe((data:string)=>{
          if(data!=null){
            this.reset();
            let obj=JSON.parse(data);
            this.global=false;
            this.isadvancefilter=true;
            this.vendorname=obj.vendorname;
            this.vendorid=obj.vendorid;
            this.reactiveFormvendor.patchValue({
              vendorname: this.vendorname
            })
            this.getpipelinelist(true,false);
          }
        }));
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
  }
  //Datavalidation
  pipelineguid(event: any) {
    this.pipelineGUID = event.target.value;
    this.pipeline = event.target.value;
  }
   
  getRouteName(event: any) {
    var val = event;
    if (!val || !String(val).trim()) {
      this.syncRouteSearchCacheFromInput('');
      return;
    }
    if (Number(val.length) + Number(1) > 3) {
        this.isLoadingResult = true;
        
         var url = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
        
        
        this.service.getapiurl(url).subscribe({
          next: data => {
            this.isLoadingResult = false;
            this.RouteNameListPipeline = data;
            this.GlobalSearchDisplayname=this.RouteNameListPipeline;
            this.RouteNameListPipeline.map(obj => obj.displayname = `${obj.displayname} ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'}`);
            this.selectedrouteDisplayName = val;
            if (data.length == 0) {
              this.notfounddata = true;
            } else {
              this.notfounddata = false
            }
          },
          error: error => {
            this.isLoadingResult = false;
            this.notfounddata = false
            this.toastr.error("No result found", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        });
    }

  }
  isadvfilter:boolean;
  selectedinterfaceEvent(item) {
    this.isadvfilter=false;
    this.reactiveFormroute.controls['routename'].setValue(item.displayname); // Update input field
    this.filteredData = [item]; 
    this.showSuggestions = false;
    this.isLoadingGS=false;
    this.selectedrouteId = item.id;
    this.selectedrouteDisplayName = item.displayname;
    this.getpipelinelist(true, false);
    // Fetch pinned messages when route is selected
    //this.loadPinnedMessages(item.id);
  }

  // Load pinned messages for a route (full list for pinned card / unpin flows)
  loadPinnedMessages(routeGuid: string): void {debugger
    if (!routeGuid) {
      this.pinnedMessages = [];
      return;
    }

    this.isLoadingPinnedMessages = true;
    this.service.getPinnedMessages(routeGuid).subscribe(
      (response: any) => {
        this.isLoadingPinnedMessages = false;
        const body = this.parsePinnedMessagesResponseBody(response);
        if (Array.isArray(body) && body.length > 0) {
          this.pinnedMessageCards = [];
          this.pinnedMessages = body;
        } else {
          this.pinnedMessages = [];
        }
      },
      error => {
        this.isLoadingPinnedMessages = false;
        this.pinnedMessages = [];
      }
    );
  }

  private parsePinnedMessagesResponseBody(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (response?.responsebody != null) {
      const rb = response.responsebody;
      if (Array.isArray(rb)) {
        return rb;
      }
      if (typeof rb === 'string') {
        try {
          const parsed = JSON.parse(rb);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      }
    }
    return [];
  }

  /**
   * For each pipeline row in the search result, calls Getpinnedmessages with that row's id
   * and stores counts so the pin icon can show only when count > 0.
   */
  loadPinnedMessageCountsForInterfaceList(rows: any[]): void {
    this.pinnedMessageCountByRouteId = {};
    if (!rows?.length) {
      return;
    }
    const ids = [...new Set(rows.map(r => r?.id).filter(id => id != null && id !== ''))].map(id => String(id));
    if (!ids.length) {
      return;
    }

    this.isLoadingPinnedMessages = true;
    const requests = ids.map(id =>
      this.service.getPinnedMessages(id).pipe(
        map((response: any) => ({
          id,
          count: this.parsePinnedMessagesResponseBody(response).length
        })),
        catchError(() => of({ id, count: 0 }))
      )
    );

    forkJoin(requests).subscribe({
      next: results => {
        this.isLoadingPinnedMessages = false;
        results.forEach(r => {
          this.pinnedMessageCountByRouteId[r.id] = r.count;
        });
      },
      error: () => {
        this.isLoadingPinnedMessages = false;
      }
    });
  }

  getPinnedMessageCountForRoute(routeId: string): number {
    if (routeId == null || routeId === '') {
      return 0;
    }
    return this.pinnedMessageCountByRouteId[String(routeId)] ?? 0;
  }

  // Unpin a message
  async unpinMessage(pinnedMessage: PinnedMessage, event: Event): Promise<void> {
    event.stopPropagation();
    const message = `Are you sure you want to unpin this message?`;
        const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "500px", data: dialogData, disableClose: true });
        const dialogResult = await dialogRef.afterClosed().toPromise();
        if (dialogResult === false) {
          return;
        }

    const sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    const pinnedBy = sessionObject?.userdata?.['userid'] || '';
    this.ngxUiLoaderService.start();
    this.service.unpinMessage(pinnedMessage.messageId, pinnedMessage.routeGuid, pinnedBy).subscribe(
      response => {
        this.ngxUiLoaderService.stop();
        this.pinnedMessages = this.pinnedMessages.filter(m => m.messageId !== pinnedMessage.messageId);
        const rg = pinnedMessage.routeGuid != null ? String(pinnedMessage.routeGuid) : '';
        if (rg && (this.pinnedMessageCountByRouteId[rg] ?? 0) > 0) {
          this.pinnedMessageCountByRouteId[rg] = this.pinnedMessageCountByRouteId[rg] - 1;
        }
        this.toastr.success('Message unpinned successfully', '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right'
        });
      },
      error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error('Failed to unpin message', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    );
  }

  // Toggle pin/unpin message from the pinned messages list
  togglePinUnpinMessage(pinnedMessage: PinnedMessage, event: Event): void {
    event.stopPropagation();
    // Since this is in the pinned messages list, the message is currently pinned
    // So clicking the pin icon will unpin it
    this.unpinMessage(pinnedMessage, event);
  }

  buildpiplinetitle(name, id) {
    if (name !== undefined && name != '') {
      if (name.includes("(")) {
        return name
      } else {
        let fullname = name + '(' + id + ')';
        if (id) {
          return fullname;
        }
        else {
          return
        }
      }
    }

  }
  async searchRouteNameCleared(event) {
    this.pagenumber = 1
    this.isadvfilter=true;
    this.status = true
    this.isChecked = false
    this.issearched = false
    this.interfacelist = []
    this.RouteNameListPipeline = []
    this.GlobalSearchDisplayname=[]
    this.interfacedetails = {}
    this.selectedrouteId = ''
    this.vendorid = ''
    this.selectedProcessorAgentguid = ''
    this.selectedSourceEntityguid = ''
    this.selectedTargetEntityguid = ''
    this.selecteddirectiontype = ''
    this.selectedrouteDisplayName = ''

    // if(this.global || this.reactiveFormroute.get('routename').value.length<1){
    //   this.reset();
    // }
    if (this.selectedrouteId !== "") {
      this.reactiveFormroute.patchValue({
        routename: ''
      });
    }
  this.filteredData = []; // Reset the dropdown data
  this.showSuggestions = false;
  this.selectedGS= ''
  }
  getstringRoute(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]}`
    return value
  }
  getstringpipleline(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }


  respopdate(value) {
    if (value.includes('/')) {
      value = value.split("/")
      return value[2] + "-" + value[0] + "-" + value[1]
    }
    else {
      value = value.split('-');
      return value[2] + "-" + value[1] + "-" + value[0]
    }
  }
  failurereasondata: any;
  async  failurerespopup(value: any, isdate: boolean, failurerespopup) {
    this.isdate = isdate;
    this.ngxUiLoaderService.start();
    this.failurereasondata = JSON.parse(JSON.stringify(value));
    this.reason = this.failurereasondata['FailureReason'];
    this.count = isdate ? "" : value['Count']
    this.failurereason = [];
    if (isdate) {
      this.fromdatepop = this.respopdate(value);
      this.todatepop = this.respopdate(value)
    }
    else {
      let date: Date = new Date();
      date.setDate(date.getDate() - 6);
      this.fromdatepop = this.datepipe.transform(date, 'yyyy-MM-dd');
      this.todatepop = this.todaydate;
      value = null
    }
    this.selecteddate = value;
    let res = await this.GetDatewiseFailureReasonList( false);
    if(failurerespopup!==null && failurerespopup!==undefined){
      const failureModalRef = this.modalService
      .open(failurerespopup, {
        windowClass: "failuremsgpop",
        backdrop: "static",
        keyboard: false,
      });
    this.trackModalRef(failureModalRef, "failuremsgpop");
    
    failureModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(failureModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(failureModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);
      this.modalWasOpen = true;
    }

  }

  async GetDatewiseFailureReasonList(isdatesearch) {
    let obj = {
      "UniqueID": this.isselect,
      "Allfailurecount": 0,
      "DatewiseFailure": this.isdate ? 1 : 0,
      "FailureReason": this.isdate ? null : this.reason,
      // "FromDate": isdatesearch || this.isdate ? this.fromdatepop + ' 00:00:00' : null,
      // "ToDate": isdatesearch || this.isdate ? this.todatepop + ' 23:59:59' : null
      "FromDate": isdatesearch || this.isdate ? this.fromdatepop : null,
      "ToDate": isdatesearch || this.isdate ? this.todatepop  : null
    }
    let isretval = false;
    this.ngxUiLoaderService.start();
    this.service.GetDatewiseFailureReasonList(obj).subscribe((data) => {
      if (data['status'].toLowerCase() == 'success') {
        this.isheaderchecked = false;
        this.failurereason = JSON.parse(data['responsebody']);
        this.failurereasonBackup = this.failurereason;
        this.ngxUiLoaderService.stop();
        isretval = true;
      }
      else {
        this.toastr.error("No data found", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.ngxUiLoaderService.stop();
        isretval = false;
      }
    }), error => {
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
      isretval = false;
    }
    return isretval;
  }
  closepopup(c) {
    c('close modal');
    this.isheaderchecked = false
    this.isopenpopup=true;
    this.failurereason = [];
    this.issuccessmsgpop='';
    let date: Date = new Date();
          date.setDate(date.getDate() - 6);
          this.fromdatepop = this.datepipe.transform(date, 'yyyy-MM-dd');
          this.todatepop = this.todaydate;
  }
  // to close Datavalidation popup screen
  closepopupdata(content: any) {

    this.showInterfaceData = false;
    this.modalService.dismissAll(content)
    this.searchtextData = '';
    this.getFilter();
    this.searchData = '';
    this.getFilterDetails();
    //this.getFilter();
    //this.getFilterDetails();
    this.selectedFromDate = '';
    this.selectedToDate = '';
  }

  isheaderchecked: boolean
  headerAction(event) {
    this.isheaderchecked = event['checked'];
    this.failurereason.forEach(V => {
      V['ischecked'] = event['checked'];
    })
  }
  rowAction(mid: any, event) {
    this.failurereason.forEach(V => {
      if (V['MessageRefernceId'] == mid['MessageRefernceId'] && V['TransactionId'] == mid['TransactionId'] && V['OrderNumber'] == mid['OrderNumber']) {
        V['ischecked'] = event['checked'];
      }
    })
  }
  async onCardSearch(key,id,name){
    this.selectedSourceEntityguid=''
    this.selectedTargetEntityguid=''
    this.vendorid=''
    this.vendorname=''
    let fulname=''
    this.reactiveFormroute.reset();
    this.reactiveFormde.reset();
    this.reactivefloderpath.reset();
    this.reactiveFormse.reset();
    this.reactiveFormmsgtype.reset();
    this.isChecked=false;
    this.reactiveFormpa.reset();
    this.reactiveFormdirection.reset();
    this.reactiveFormvendor.reset();
    this.reactiveFormProject.reset();
    this.fromdate='';
    this.todaydate='';
    this.isadvfilter=true
    this.selectedrouteId=''
    switch(key){
    case 'se':
      this.selectedSourceEntityguid=id
      fulname=name+ '(' +id + ')';
      this.reactiveFormse.patchValue({'sename':fulname});
      break
    case 'de':
      this.selectedTargetEntityguid=id
      fulname=name+ '(' +id + ')';
      this.reactiveFormde.patchValue({'dename':fulname});
      break
    case 'vendor':
      this.vendorid=id
      this.vendorname=name
      this.reactiveFormvendor.patchValue({
        vendorname: this.vendorname
      })
      break
    }
    let obj={
      "SEGUID": this.selectedSourceEntityguid,
       "DEGUID": this.selectedTargetEntityguid,
       "vendor": this.vendorid,
       "pagenumber": 1,
       "PageSize": this.PageSize,
       "userType": (this.isChecked) ? 2 : '',
       "type": 'not',
       "status": this.status ? "active" : "passive"
    }
    var apiname = 'api/Routes/GetSearchDetails';
    this.ngxUiLoaderService.start();
    this.response = await this.service.searchpostapi(apiname, obj);

    if (this.response.length == 0) {
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.interfacelist = []
      this.totalrecords = 0
      this.paginator.firstPage();
    } else {
      this.interfacelist = []
      this.global=false;
      this.isadvancefilter=true;
      this.showSourceTarget=false;

      this.paginator.firstPage();
      this.interfacelist = this.response as any[]
      this.totalrecords = parseInt(this.response[0].totalpipelinecount.toString());
      if (this.pagenumber > 0 && this.paginator != undefined) {
        this.paginator.length = this.totalrecords;
      }
    }
    this.ngxUiLoaderService.stop();
  }

  async  getpipelinelist(issearch, isscroll) {
    if (!isscroll) {
      this.interfacelist = []
      this.isselect = ''
      this.issearched = issearch
    }
    let obj = {}
    this.ngxUiLoaderService.start();
    this.interfacedetails = []
    if (this.fromdate != '' && this.todate == '') {
      this.toastr.warning("Unable to search", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
      // Close pinned messages
      this.expandedIds.clear();
    }
    else {
      if (this.selectedrouteId != '') {
        obj = {
          "id": this.selectedrouteId,
        }
      }
      else {
          if (this.selectedSourceEntityguid == '' && this.reactiveFormse.get('sename').value) {
          this.selectedSourceEntityguid = this.reactiveFormse.get('sename').value.id;
        }

        if (this.selectedTargetEntityguid == '' && this.reactiveFormde.get('dename').value) {
          this.selectedTargetEntityguid = this.reactiveFormde.get('dename').value.id;
        }

        if (this.selectedEntityguid == '' && this.reactiveFormentity.get('entityname').value) {
          if (this.selectedSourceEntityguid == '' && this.selectedTargetEntityguid == '') {
            this.selectedEntityguid = this.reactiveFormentity.get('entityname').value.id;
          }
          else {
            this.selectedEntityguid = '';
          }
        }
        else if (this.selectedSourceEntityguid !== '' || this.selectedTargetEntityguid !== '') {
          this.selectedEntityguid = '';
        }

        if (this.selectedProcessorAgentguid == '' && this.reactiveFormpa.get('paname').value) {
          this.selectedProcessorAgentguid = this.reactiveFormpa.get('paname').value.id;
        }
        
        if (issearch) {
         // setTimeout(() => {
            this.paginator.firstPage();
            this.pagenumber = 1;
          //}, 1000);
        }
        obj = {
          "messagetype": this.selectedmessagetype,
          "id": this.selectedrouteId,
          "PAID": this.selectedProcessorAgentguid,
          "sourceagentid": "",
          "SEGUID": this.selectedSourceEntityguid,
          "destinationagentid": "",
          "DEGUID": this.selectedTargetEntityguid,
          "vendor": this.vendorid,
          "entityid": this.selectedEntityguid,
          "pagenumber": this.pagenumber,
          "PageSize": this.PageSize,
          "userType": (this.isChecked) ? 2 : '',
          "type": 'not',
          "projectId": this.selectedprojId,
          "assignedUserId": (this.isChecked) ? JSON.parse(sessionStorage.getItem('rolewithmenus'))[0].uniqueId : '',
          "status": this.status ? "active" : "passive",
          "FromDate": this.fromdate,
          "ToDate": this.todate,
          "Direction": this.selecteddirectiontype,
          "DateType": this.fromdate != '' && this.todate != '' ? this.dateoption : '',
          "SETYPE": this.selectedSourceEntitytype,
          "DETYPE": this.selectedTargetEntitytype,
          "SEDEPLOYMENTKEY": this.selectedSourcedeploymentkey,
          "DEDEPLOYMENTKEY": this.selectedtargetedeploymentkey,
          "EETYPE": this.selectedEntitytype,
          "EEDEPLOYMENTKEY": this.selectedEntitydeploymentkey,
          "folderpath":this.reactivefloderpath.get('folderPath').value
        }
      }
    
      var apiname = 'api/Routes/GetSearchDetails';
      this.response = await this.service.searchpostapi(apiname, obj);

      if (this.response.length == 0) {
        this.toastr.error("No data found", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.interfacelist = []
        this.totalrecords = 0
        this.paginator.firstPage();
        // Close pinned messages
      this.expandedIds.clear();
        this.pinnedMessageCountByRouteId = {};
      } else {
        this.interfacelist = []
        this.interfacelist = this.response as any[]
        this.totalrecords = parseInt(this.response[0].totalpipelinecount.toString());
        if (this.pagenumber > 0 && this.paginator != undefined) {
          this.paginator.length = this.totalrecords;
        }
        // Close pinned messages
      this.expandedIds.clear();
        this.loadPinnedMessageCountsForInterfaceList(this.interfacelist);
      }
      this.ngxUiLoaderService.stop();
    }
  }
  datesplit(value) {
    if (value !== undefined) {
      value = value.split(" ")[0]
      if (value.includes("-")) {
        value = value.split("-")
        return value[1] + "/" + value[0] + "/" + value[2]
      }
      else if (value.includes("/")) {
        value = value.split("/")
        return value[1] + "/" + value[0] + "/" + value[2]
      }
    }
  }

  formatInSelectedTimezone(value: any): string {
    if (value == null || value === '') {
      return '';
    }
    const raw = typeof value === 'string' ? value.trim() : String(value).trim();
    if (!raw) {
      return '';
    }
    return this.service.convertDateTimeString(raw) || raw;
  }
  valueData:any;
  getpipelinedetails(interfaceData: any, value) {
    this.valueData=value
    if (value == 'home') {
      this.DiagnosticList = []
      this.connseqdatalist = []
      this.seqdataarr = []
      this.isselect = interfaceData.UniqueID
      this.selectedRoutGUID = interfaceData.id;
      this.selectedRouteName = interfaceData.displayname;
      this.sourcedeploy = interfaceData['SEDEPLOYMENTKEY'];
      this.targetdeploy = interfaceData['DEDEPLOYMENTKEY'];
      this.sourcetype = interfaceData['SETYPE'];
      this.targettype = interfaceData['DETYPE'];
      this.mode = interfaceData['mode']
      this.ngxUiLoaderService.start();
    }
    this.issuccessmsgpop=''
    this.service.GetPipeleDetailsByUniqueID(interfaceData.UniqueID).subscribe((data) => {
      this.ngxUiLoaderService.stop();
      if (data['status'].toLowerCase() == 'success' && (data['statusmessage'] == null || data['statusmessage'].toLowerCase() != 'no data found')) {
        this.ishide = false
        this.interfacedetails = JSON.parse(data['responsebody']);
        this.pipeLineDetails = this.interfacedetails['pipeLineDetails'][0];
        this.interfacedetails['connectivityDetails']['sequenceDataList'] != null && this.interfacedetails['connectivityDetails']['sequenceDataList'][0] != undefined ? this.sequence = this.interfacedetails['connectivityDetails']['sequenceDataList'] : this.sequence = [];
        this.interfacedetails['pipeLineDetails'][0]['UniqueID']=interfaceData.UniqueID;
        this.loadRuleEngineStatus(interfaceData.UniqueID);
         this.getsuccessmsglist('');
        // if (this.connseqdatalist.length == 0) {
        //   this.sequence = []
        // }
        this.category = []
        this.interfacedetails['DateWiseFailureCount'].forEach(Element => {
          this.category.push(Element['Date'])
        });
        // let fail=[]
        // this.interfacedetails['DateWiseFailureCount'].forEach(Element =>{
        //   fail.push(parseInt(Element['StatusCount']['FailureCcount']))
        // });
        // let ignore=[]
        // this.interfacedetails['DateWiseFailureCount'].forEach(Element =>{
        //   ignore.push(parseInt(Element['StatusCount']['IgnoreCount']))
        // });
        // let success=[]
        // this.interfacedetails['DateWiseFailureCount'].forEach(Element =>{
        //   success.push(parseInt(Element['StatusCount']['SuccessCount']))
        // });
        // let resolved=[]
        // this.interfacedetails['DateWiseFailureCount'].forEach(Element =>{
        //   resolved.push(parseInt(Element['StatusCount']['ResolvedCount']))
        // });
        // this.chartOptions={
        //   chart: {
        //     type: 'column',
        //   },
        //   title: {
        //     text: ''
        //   },
        //   exporting: {
        //     enabled: false
        //   },
        //   xAxis: {

        //     categories: this.category,
        //     labels: {
        //       style: {
        //           color: 'black',
        //           fontSize:'9px'
        //       }
        //   },
        //     crosshair: true
        //   },
        //   yAxis: {
        //     title: {
        //       text: ''
        //     }
        //   },
        //   tooltip: {
        //     headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        //     pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        //       '<td style="padding:0"><b>{point.y:1f}</b></td></tr>',
        //     footerFormat: '</table>',
        //     shared: true,
        //     useHTML: true
        //   },
        //   plotOptions: {
        //     column: {
        //       pointPadding: 0.2,
        //       borderWidth: 0
        //     },
        //   },
        //   series: [{
        //     name: 'Failure',
        //     data: fail

        //   }, {
        //     name: 'Ignored',
        //     data: ignore

        //   }, {
        //     name: 'Success',
        //     data: success

        //   }, {
        //     name: 'Resolved',
        //     data: resolved
        //   }],
        //   credits: {
        //     enabled: false
        // },
        // }
      }
      else {
        this.toastr.error("Unable to fetch pipeline details", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }), error => {
      this.toastr.error("Unable to fetch pipeline details", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    }
  }
  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }

  }
  reprocessdata(c,ciismessagereprocess){
    let selectedmsgs=this.failurereason.filter(element => element["ischecked"]==true);
    if(selectedmsgs.length>0){
      const reprocessModalRef = this.modalService.open(ciismessagereprocess,{windowClass: "ciismessagereprocess",backdrop: 'static', keyboard: false});
      this.trackModalRef(reprocessModalRef, "ciismessagereprocess");
      
      reprocessModalRef.result.then(
        (result) => {
          this.modalWasOpen = false;
          this.untrackModalRef(reprocessModalRef);
        },
        (reason) => {
          this.modalWasOpen = false;
          this.untrackModalRef(reprocessModalRef);
        }
      );
      
      // Add data attribute to identify the modal and backdrop
      setTimeout(() => {
        const modalElement = document.querySelector('.modal.show') as HTMLElement;
        if (modalElement) {
          modalElement.setAttribute('data-interface-modal', 'true');
        }
        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
        if (backdrop) {
          backdrop.setAttribute('data-interface-modal', 'true');
        }
      }, 100);
      
      this.modalWasOpen = true;
    }
  }

  reportexport(value: string) {
    this.ngxUiLoaderService.start()
    let reporttype = ''
    value != '' ? reporttype = 'default' : this.isdate ? reporttype = 'datewise' : reporttype = 'failurewise'
    let obj = {
      "routeID": this.pipeLineDetails['Id'],
      "direction": this.pipeLineDetails['Direction'],
      "displayname": this.pipeLineDetails['DisplayName'],
      "messageType": this.pipeLineDetails['Messagetype'],
      "lab": (this.pipeLineDetails['Direction'].toLowerCase()).includes('Inbound') ? this.pipeLineDetails['DestinationEntity'] : this.pipeLineDetails['SourceEntityName'],
      "vendor": this.pipeLineDetails['VendorName'],
      "connectivity": "",
      "user": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      "reportType": reporttype,
      "failureDate": reporttype=='datewise'?this.selecteddate:null,
      "failureReason": this.reason,
      "uniqueId": this.isselect,
      "fromDate":this.fromdatepop,
      "toDate": this.todatepop
    }

    this.service.ciisreportexport(obj).subscribe(data => {
      if (data['status'] != null && data['status'].toLowerCase() == 'success') {
        this.base64data = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + data['responsecontent'];
        this.downloadfile();
      }
      else {  
        this.toastr.error("Unable to export report", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      this.ngxUiLoaderService.stop();
    }), error => {
      this.toastr.error("Unable to export report", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    }
  }
  downloadfile() {
    const source = this.base64data;
    const link = document.createElement("a");
    link.href = source;
    link.download = 'InterfaceHistory_' + this.todaydate;
    link.click();
  }


  backtolist() {
    this.interfacedetails = []
    this.ishide = true
    this.showdiagnostics = false;
    this.fromdatepop='';
    this.todatepop='';
    this.failurereason=[];
    this.successmsglist=[];
  }
  myinterface(event: any) {
    this.isChecked = event.checked;
  }

  async getProcessorAgentNames(event: any) {
    this.isLoadingpa = true;
    var apiname = "api/Agents/GetByDisplayName?name=" + '&agentid=0&type=Processor&filterflag=false';

    await this.service.getapiurl(apiname).subscribe({
      next: async data => {
        this.ProcessorAgentNameList = data
        this.ProcessorAgentNameList.map(obj => { obj.name = obj.displayname, obj.displayname = `${obj.displayname}  ${'(' + obj.id + ')'}` });
        this.ProcessorList = this.ProcessorAgentNameList;
        this.isLoadingpa = false;
        if (data.length == 0) {
          this.notfounddata = true;
        } else {
          if (this.ProcessorList.length > 0) {
            this.ProcessorList = this.service.transformAlphabetically(this.ProcessorList, 'displayname');
          }
          this.notfounddata = false;
        }
      },
      error: error => {
        this.isLoadingpa = false;
        this.notfounddata = true;
      }
    });
  }

  selectedProcessorAgents(item) {
    this.selectedProcessorAgentguid = item.id;
    this.selectedProcessorAgentName = item.displayname;
  }
  searchProcessorAgentCleared(event) {
    this.isLoadingpa = false;
    // this.ProcessorAgentNameList = this.ProcessorList;
    this.ProcessorAgentNameList = [];
    this.selectedProcessorAgentguid = '';
    this.notfounddata = false;
  }
  selectedmessagetype: string = '';
  selectedmessagetypeevent(item) {
    this.selectedmessagetype = item.displayname;
  }
  selecteddirectiontype: string = ''
  selecteddirectiontypeevent(item) {
    this.selecteddirectiontype = item.name;
  }
  Clearemessagetype(event) {
    this.selectedmessagetype = '';
    // this.messageTypeList = this.messageTypeAllList;
    this.messageTypeList = [];
  }
  Cleardirectiontype(event) {
    this.selecteddirectiontype = '';
    // this.messageTypeList = this.messageTypeAllList;
    //this.directionlist = [];
  }


  getMessagetypelist(event) {
    this.isLoadingmessagetype = true;
    if (event !== 'msgtype') {
      if (event == undefined) {
        this.messageTypeList = this.messageTypeAllList;
      }
      else {
        if (this.messageTypeList.length == 0) {
          this.messageTypeList = this.messageTypeAllList;
        }
        this.messageTypeList = this.messageTypeList.filter(t => t.displayname.toLowerCase().includes(event.toLowerCase()));
      }
      if (this.messageTypeList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingmessagetype = false;
    }
    else {

      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype").subscribe({
        next: data => {
          data.forEach(element => {
            this.messageTypeAllList.push({ displayname: element });
          });
          this.messageTypeList = this.messageTypeAllList;

          this.isLoadingmessagetype = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingmessagetype = false;
          this.notfounddata = true;
        }
      });
    }

  }
  reset() {
    this.searchEntityCleared();
    this.searchSourceEntityCleared(event);
    this.searchTargetEntityCleared(event);
    this.ishide=true;
    this.interfacedetails={};
    this.showSourceTarget=true;
    this.isopenpopup=true;
    this.issuccessmsgpop='';
    this.failurereason=[];
    this.successmsglist=[];
    this.paginator!=undefined?this.paginator.pageIndex = 0:'';
    this.isviewpassword = false;
    this.pagenumber = 1
    this.interfacelist = []
    this.reactiveFormdirection.reset();
    this.isChecked = false
    this.status = true
    this.fromdate = ''
    this.todate = ''
    this.fromdatepop = ''
    this.todatepop = ''
    this.reactiveFormProject.reset();
    this.isadvancefilter = false;
    this.showexportbutton = false;
    this.reactiveFormroute.reset();
    this.reactiveFormpa.reset();
    this.reactiveFormde.reset();
    this.reactivefloderpath.reset()
    this.reactiveFormse.reset();
    this.selectedProcessorAgentguid = "";
    this.selectedrouteId = "";
    this.selectedmessagetype = '';
    this.selectedSourceEntityguid = "";
    this.selectedTargetEntityguid = "";
    this.selectedEntityguid = "";
    this.vendorname = "";
    this.reactiveFormvendor.reset();
    this.reactiveFormvendor.setValue({ "vendorname": '' });
    this.Vendornamelist = this.VendornameBackuplist;
    this.ProcessorAgentNameList = this.ProcessorList;
    this.reactiveFormpa.setValue({ "paname": '' });
    this.reactiveFormmsgtype.reset();
    this.reactiveFormmsgtype.setValue({ "msgname": '' });
    this.reactiveFormdirection.setValue({ "direction": '' });
    this.pagenumber = 0;
    if (!this.showSourceTarget) {
      this.showSourceTarget = true;
    }
    this.messageTypeList = this.messageTypeAllList;
    this.reactiveFormentity.reset();
    this.selectedEntityName = '';
    this.totalrecords = 0;
    this.selectedprojId = '';
    this.isLoadingGS=false;
    this.selectedGS='';
    this.vendorid="";
    this.CallBySearchBar=false;
// Close pinned messages
    this.expandedIds.clear();
    this.clearCompareSource();
  }

  getVendornames() {
    var url = "api/Vendor/GetVendorName";
    this.service.getapiurl(url).subscribe(data => {
      if (data) {
        this.Vendornamelist = data
        this.Vendornamelist = this.service.transformAlphabetically(this.Vendornamelist, 'name');
        this.VendornameBackuplist = this.Vendornamelist;
      }
    })
  }
  selectedVendor(item) {
    this.vendorname = item.name;
    this.vendorid = item.Id
  }
  searchVendorCleared() {
    this.isLoadingvendor = false;
    this.vendorname = "";
    this.Vendornamelist = this.VendornameBackuplist;
    this.vendorid="";
    this.reactiveFormvendor.setValue({ "vendorname": '' });
  }
  getVendorName(event) {
    this.isLoadingvendor = false;
    if (this.Vendornamelist.length > 0) {
      this.filtervendorlist(event);
    }
    else {
      this.Vendornamelist = this.VendornameBackuplist;
      this.filtervendorlist(event);
    }
  }
  filtervendorlist(event) {
    this.Vendornamelist = this.Vendornamelist.filter(t => t.name.toLowerCase().includes(event.toLowerCase()));
    if (this.Vendornamelist.length == 0) {
      this.notfounddata = true;

    } else {
      this.notfounddata = false;
    }
    this.isLoadingvendor = false;
  }

  selectedEntity(item) {
    this.selectedEntityguid = item.LocationGUID;
    this.selectedEntityName = item.LocationName;
    this.selectedEntitytype = item.TypeName;
    this.selectedEntitydeploymentkey =item.deploymentkey;
  }
  EntityNameListCleare() {
    this.selectedEntityguid = '';
    this.selectedEntityName = '';
    this.selectedEntitytype = '';
    this.selectedEntitydeploymentkey ='';
  }


  searchEntityCleared() {
    this.isLoadingentity = false;
    this.EntityNameList = [];
    this.selectedEntityguid = '';
    this.notfounddata = false;
  }
  entityCustomFilter = function (EntityNameList: any[], query: string): any[] {
    return EntityNameList;
  };
  async getEntityNames(event: any) {

    var valuesa = event;
    let highlighted;
    if (event.includes(":")) {
      let splitValues = event.split(':')
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":")
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":")
      }
    }
    if (highlighted != "") {
      highlighted = event;
    }
    this.selectedEntityguid = '';
    this.reactiveFormentity.patchValue({
      entityname: event
    })
    if (valuesa != '' && !valuesa.endsWith(":") && !valuesa.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(": ", ":");
      // var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;
      this.isLoadingentity = true;
      let obj = {
        lSearch: valueToSendToApiWithOutWhiteSpace
      }
      //let response = await this.service.getapi(createSearch);
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response['status'] && response['statusText']) {
          this.EntityNameList = [];
          this.isLoadingentity = false;
          this.notfounddata = true;
          this.toastr.error("Unable to fetch Entity Details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        } else {
          if (response.length > 0) {
            this.EntityNameList = response;
            this.EntityNameList = this.service.transformAlphabetically(this.EntityNameList, 'LocationName');
            this.EntityNameList.map(obj => obj.LocationName = obj.UniqueID !== null && obj.UniqueID !== undefined ? `${obj.LocationName} ${'(' + obj.LocationGUID + ')'} ${'(' + obj.UniqueID + ')'}` : `${obj.LocationName} ${'(' + obj.LocationGUID + ')'}`);
          }

          if (response.length == 0) {
            this.EntityNameList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedEntityguid = '';
          this.isLoadingentity = false;
        }
      })
    }
    else {
      this.EntityNameList = [];
      this.notfounddata = true;
    }
  }
  locationString(item, item1, item2) {
    let names = item2.split("(")
    item2 = names[2] !== 'null)' && names[2] !== undefined ? `${names[0]} <br> (${names[1]} <br> (${names[2]}` : `${names[0]} <br> (${names[1]}`
    return '(' + item + ')' + ' ' + item1 + ' : ' + item2
  }
  buildtitle(Obj: any) {
    if (typeof (Obj) == "object" && Obj != null) {
      let name = `(${Obj.Type}):${Obj.LocationName}
      ${Obj.Address1}
      `
      return name;
    }
  }

  selectedSourceEntity(item) {
    this.selectedSourceEntityguid = item.LocationGUID;
    this.sourceIsTestOrganization = this.normalizeTestOrgFlagValue(item?.istestorganization);
    this.testOrgFlagsLoadedForSourceGuid = item.LocationGUID;
    this.selectedSourceEntityName = item.LocationName;
    this.selectedSourcedeploymentkey = item.deploymentkey;
    this.selectedSourceAssociateAaccountids = item.associatedaccountids;
    this.selectedSourceEntitytype = item.TypeName;
  }

  searchSourceEntityCleared(event) {
    this.isLoadingse = false;
    this.SourceEntityNameList = [];
    this.selectedSourceEntityguid = '';
    this.notfounddata = false;
    this.selectedSourcedeploymentkey = '';
    this.selectedSourceAssociateAaccountids = '';
  }
  sourceCustomFilter = function (SourceEntityNameList: any[], query: string): any[] {
    return SourceEntityNameList;
  };

  async getSourceEntityNames(event: any) {
    var valuesa = event;
    let highlightedSource;
    if (event.includes(":")) {
      let splitValues = event.split(':')
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":")
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":")
      }
    }
    if (highlightedSource != "") {
      highlightedSource = event;
    }
    this.selectedSourceEntityguid = '';
    this.reactiveFormse.patchValue({
      sename: event
    })
    if (valuesa != '' && !valuesa.endsWith(":") && !valuesa.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(": ", ":");
      //var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;
      this.isLoadingse = true;

      //let response = await this.service.getapi(createSearch);
      let obj = {
        lSearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedTargetEntityguid,
        deploymentkey: this.selectedtargetedeploymentkey,
        associatedaccountids: this.selectedtargetAssociateAaccountids
      }
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response['status'] && response['statusText']) {
          this.SourceEntityNameList = [];
          this.notfounddata = true;
          this.isLoadingse = false;
          this.toastr.error("Unable to fetch Source Details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        } else {
          if (response.length > 0) {
            this.SourceEntityNameList = response;
            this.SourceEntityNameList = this.service.transformAlphabetically(this.SourceEntityNameList, 'LocationName');
            this.SourceEntityNameList.map(obj => obj.LocationName = obj.UniqueID !== null && obj.UniqueID !== undefined ? `${obj.LocationName} ${'(' + obj.LocationGUID + ')'} ${'(' + obj.UniqueID + ')'}` : `${obj.LocationName} ${'(' + obj.LocationGUID + ')'}`);
          }
          if (response.length == 0) {
            this.SourceEntityNameList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedSourceEntityguid = '';
          this.isLoadingse = false;
        }
      })
    }
    else {
      this.SourceEntityNameList = [];
      this.notfounddata = true;
    }
  }

  selectedTargetEntity(item) {
    this.selectedTargetEntityguid = item.LocationGUID;
    this.destinationIsTestOrganization = this.normalizeTestOrgFlagValue(item?.istestorganization);
    this.testOrgFlagsLoadedForDestGuid = item.LocationGUID;
    this.selectedTargetEntityName = item.LocationName;
    this.selectedtargetedeploymentkey = item.deploymentkey;
    this.selectedtargetAssociateAaccountids = item.associatedaccountids;
    this.selectedTargetEntitytype = item.TypeName;
  }

  searchTargetEntityCleared(event) {
    this.isLoadingde = false;
    this.TargetEntityNameList = [];
    this.selectedTargetEntityguid = '';
    this.notfounddata = false;
    this.selectedtargetedeploymentkey = '';
    this.selectedtargetAssociateAaccountids = '';

  }
  targetCustomFilter = function (TargetEntityNameList: any[], query: string): any[] {
    return TargetEntityNameList;
  };

  async getTargetEntityNames(event: any) {
    var valueta = event;
    let highlightedTarget;
    if (event.includes(":")) {
      let splitValues = event.split(':')
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":")
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":")
      }
    }
    if (highlightedTarget != "") {
      highlightedTarget = event;
    }
    this.selectedTargetEntityguid = '';
    this.reactiveFormde.patchValue({
      dename: event
    })
    if (valueta != '' && !valueta.endsWith(":") && !valueta.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valueta.replaceAll(": ", ":");
      //var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;
      this.isLoadingde = true;
      let obj = {
        lSearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedSourceEntityguid,
        deploymentkey: this.selectedSourcedeploymentkey,
        associatedaccountids: this.selectedSourceAssociateAaccountids
      }
      //let response = await this.service.getapi(createSearch);
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response['status'] && response['statusText']) {
          this.TargetEntityNameList = [];
          this.notfounddata = true;
          this.isLoadingde = false;
          this.toastr.error("Unable to fetch Target Details", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        } else {
          if (response.length > 0) {
            this.TargetEntityNameList = response as any[];
            //this.TargetEntityNameList = this.service.transformAlphabetically(this.TargetEntityNameList, 'LocationName');
            this.TargetEntityNameList.map(obj => obj.LocationName = obj.UniqueID !== null && obj.UniqueID !== undefined ? `${obj.LocationName} ${'(' + obj.LocationGUID + ')'} ${'(' + obj.UniqueID + ')'}` : `${obj.LocationName} ${'(' + obj.LocationGUID + ')'}`);
          }
          if (response.length == 0) {
            this.TargetEntityNameList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedTargetEntityguid = '';
          this.isLoadingde = false;
        }
      })
    }
    else {
      this.TargetEntityNameList = [];
      this.notfounddata = true;
    }
  }

  selectedProject(item) {
    this.selectedprojId = item.id,
      this.selectedProjName = item.projectName
    this.pagenumber = 1;
    this.totalrecords = 0;
  }

  getProjectNames(event: any) {

    var val = event;
    if (val) {
      this.isLoadingProjects = true;
      // var apiname = "api/Projects/GetProjectNames?searchStr="+ val ;
      this.service.getProjList(val).subscribe(data => {
        if (data.statusmessage.length == 0 || data.statusmessage == "No data found") {
          this.notfoundProj = true;
          this.isLoadingProjects = false;
        } else if (data.statusmessage.length > 0) {
          this.ProjectNames = JSON.parse(data.statusmessage);
          this.ProjectNames.find(obj => obj.projectName = `${obj.projectName} ${'(' + obj.projectId + ')'}`);
          this.isLoadingProjects = false;
          //   if(filterd.length>0){
          //   for(let i=0;i<filterd.length;i++){
          //   this.reactiveFormProject.patchValue({projectName:filterd[i].projectName})
          //   }
          // }
        }
        else {
          this.notfoundProj = false;
          this.isLoadingProjects = false;
        }
      }, error => {
        this.isLoadingProjects = false;
        this.notfoundProj = true;
      })
    }
  }

  searchProjectCleared(event) {
    this.isLoadingProjects = false;
    this.ProjectNames = [];
    this.selectedProjName = '';
    this.selectedprojId = '';
    this.notfoundProj = false;
  }
  openvarulepopup() {
    var dpkeyname = '';
    if ((this.pipeLineDetails['Direction'].toLowerCase()).includes('inbound')) {
      dpkeyname = this.targetdeploy;
    }
    else {
      dpkeyname = this.sourcedeploy;
    }

    let dataToruleModal = {
      routename: this.pipeLineDetails['DisplayName'],
      islocked: this.pipeLineDetails['Islocked'] != null ? this.pipeLineDetails['Islocked'] : false,
      deploymentkey: dpkeyname
    };
    if (this.sourcetype.toLowerCase() == 'organization') {
      dataToruleModal["LabOrgId"] = this.pipeLineDetails['SourceEntityId'];
    }
    else if (this.sourcetype.toLowerCase() == 'account') {
      dataToruleModal["LabId"] = this.pipeLineDetails['SourceEntityId'];
    }

    if (this.targettype.toLowerCase() == 'organization') {
      dataToruleModal["OrdFacOrgId"] = this.pipeLineDetails['DestinationEntityId'];
    }
    else if (this.targettype.toLowerCase() == 'account') {
      dataToruleModal["OrdFacilityId"] = this.pipeLineDetails['DestinationEntityId'];
    }
    else if (this.targettype.toLowerCase() == 'facility') {
      dataToruleModal["OrdFacilityId"] = this.pipeLineDetails['DestinationEntityId'];
    }
    const varulesModalRef = this.modalService.open(VarulesComponent,
      { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
    varulesModalRef.componentInstance.inputDataInModalComponent = dataToruleModal;
    this.trackModalRef(varulesModalRef, "myCustomModalClass");
    
    varulesModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(varulesModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(varulesModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }

  shouldShowRuleButton(): boolean {
    const direction = (this.pipeLineDetails['Direction'] || '').toString().toLowerCase();
    if (direction.includes('inbound')) {
      return false;
    }
    if (this.isRuleEngine) {
      return true;
    }
    const vendor = (this.pipeLineDetails['VendorName'] || '').toString().toLowerCase();
    return vendor !== 'device';
  }

  openRuleOrVaRule(): void {
    if (this.isRuleEngine) {
      this.openRuleConfigDialog();
    } else {
      this.openvarulepopup();
    }
  }

  private loadRuleEngineStatus(uniqueId: string): void {
    this.isRuleEngine = false;
    this.ruleConfigVersionsList = [];
    if (!uniqueId) {
      return;
    }
    this._ruleEngineService.GetRuleConfigVersions(uniqueId, 'Validation').subscribe({
      next: (versions: any) => {
        const raw = Array.isArray(versions) ? versions : [];
        this.ruleConfigVersionsList = raw;
        this.isRuleEngine = raw.length > 0;
      },
      error: () => {
        this.ruleConfigVersionsList = [];
        this.isRuleEngine = false;
      }
    });
  }

  async openRuleConfigDialog(): Promise<void> {
    try {
      const uniqueId = this.isselect || this.pipeLineDetails['UniqueID'];
      const routeId = this.selectedRoutGUID || this.pipeLineDetails['Id'];
      const routeName = this.pipeLineDetails['DisplayName'] || '';

      this.ngxUiLoaderService.start();
      const raw = await this._ruleEngineService.GetRuleConfigVersions(uniqueId, 'Validation').toPromise();
      this.ngxUiLoaderService.stop();

      const list = Array.isArray(raw) ? raw : [];
      this.ruleConfigVersionsList = list;
      const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
      const finalRuleData = hasExistingRules ? ruleData : [];

      const sourceGuid = this.pipeLineDetails['SourceEntityId'] || '';
      const targetGuid = this.pipeLineDetails['DestinationEntityId'] || '';
      await this.ensureTestOrganizationFlagsLoaded(sourceGuid, targetGuid);

      this.dialog.open(RuleConfigComponentComponent, {
        maxWidth: '95vw',
        height: '96%',
        width: '100%',
        data: {
          data: finalRuleData,
          isView: hasExistingRules,
          routeGuid: routeId,
          routeName,
          routeUniqueID: uniqueId,
          ruleConfigVersions: list,
          ruleExecutionStage: 'Validation',
          componentname: 'interface',
          dialogTitle: 'Pipeline Rules',
          ...this.getTestOrganizationFlagsForChildDialogs(),
        },
        autoFocus: false,
        disableClose: true,
        panelClass: 'rule-config-dialog-container'
      });
    } catch {
      this.ngxUiLoaderService.stop();
      this.toastr.error('An unexpected error occurred', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }

  checkStatus(connectivity: any) {
    if (connectivity !== undefined) {
      let val = connectivity.LableValue.filter(
        (value) => value.status === false
      );
      if (val.length > 0) {
        connectivity["status"] = "Failed";
      } else {
        connectivity["status"] = "Success";
      }
    }
  }

  async exportreport() {
    let routeStatus=this.status ? "active" : "passive";
    this.CallBySearchBar?routeStatus=routeStatus:'';
    const assignedUserId = this.isChecked ? JSON.parse(sessionStorage.getItem('rolewithmenus'))[0].uniqueId : '';
    const fileName = 'PipelineList.xlsx';
    if(this.global || this.selectedGS!= ""){
      const url = this.global
      ? `api/Routes/GetByInterfaceDetail?name=${this.selectedGS}&version=0&global=${this.global}&pagenumber=${0}&status=${routeStatus}&assignedUserId=${assignedUserId}&callBySearchBar=${this.CallBySearchBar}`
      : `api/Routes/GetByInterfaceDetail?name=${this.selectedGS}&version=0`;

      this.ngxUiLoaderService.start();
    // Fetch data from API
    this.service.getapiurl(url).subscribe({
      next: (data) => {
  if(data.length >= 0)
  {
    this.ngxUiLoaderService.stop();
  this.exportToExcel(data, fileName);
  }
  else{
    this.ngxUiLoaderService.stop();
  }
  
  }
  });
    }
    else {
      var searchData = {
        "messagetype": this.selectedmessagetype,
        "id": this.selectedrouteId,
        "PAID": this.selectedProcessorAgentguid,
        "sourceagentid": "",
        "SEGUID": this.selectedSourceEntityguid,
        "destinationagentid": "",
        "DEGUID": this.selectedTargetEntityguid,
        "vendor": this.vendorid,
        "entityid": this.selectedEntityguid,
        "pagenumber": 0,
        "PageSize": this.PageSize,
        "userType": (this.isChecked) ? 2 : '',
        "type": 'not',
        "projectId": this.selectedprojId,
        "assignedUserId": (this.isChecked) ? JSON.parse(sessionStorage.getItem('rolewithmenus'))[0].uniqueId : '',
        "status": this.status ? "active" : "passive",
        "FromDate": this.fromdate,
        "ToDate": this.todate,
        "Direction": this.selecteddirectiontype,
        "DateType": this.fromdate != '' && this.todate != '' ? this.dateoption : '',
        "SETYPE": this.selectedSourceEntitytype,
        "DETYPE": this.selectedTargetEntitytype,
        "SEDEPLOYMENTKEY": this.selectedSourcedeploymentkey,
        "DEDEPLOYMENTKEY": this.selectedtargetedeploymentkey,
        "EETYPE": this.selectedEntitytype,
        "EEDEPLOYMENTKEY": this.selectedEntitydeploymentkey,
        "folderpath":this.reactivefloderpath.get('folderPath').value
      };
      var apiname = 'api/Routes/GetSearchDetails';
      this.ngxUiLoaderService.start();
  
      let response = await this.service.searchpostapi(apiname, searchData);
  
     
      this.exportToExcel(response, fileName);
      this.ngxUiLoaderService.stop();
    }
    
  }

  exportToExcel(items: any[], fileName: string): void {

    const selectedItems = items.map(item => {
      return {
        "Pipeline Name": item.displayname,
        "GUID": item.id,
        "Source Entity": item.SENAME,
        "Destination Entity": item.DENAME,
        "Source Agent": item.SourceAgent,
        "Destination Agent": item.DestinationAgent,
        "Processor Type": item.PANAME,
        "Message Type": item.messagetype,
        "Direction": item.Direction,
        "Mode": item.mode,
        "Connectivity": item.Connectivity,
        "Vendor": item.vendor,
        "Created Date ": item.CreatedDate,
        "Go-Live Date": item.GoLiveDate,
        "Last Transaction Date": item.LastTransactionDate,
        "Status": item.status,
        "Pre-Validation": item.isvalidationack
      };
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(selectedItems);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob: Blob = new Blob([excelBuffer], { type: 'application/xml' });
    //saveAs(blob, fileName);
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

  }

  getSearchbyAccessionorOrderNumber(event) {
    let searchtext = event.target.value.toLowerCase();
    if (searchtext !== '') {
      this.failurereason = this.failurereasonBackup.filter(s => s.OrderNumber.toLowerCase().includes(searchtext) || s.AccessionNumber.toLowerCase().includes(searchtext));
    }
    else {
      this.failurereason = JSON.parse(JSON.stringify(this.failurereasonBackup));
    }
  }

  //The below method will be called when the user clicks on the data validation button under drop down
  OnValidation(content: any, data: any) {
    this.getInterfaceValidationHistoryInfo();
    this.pipelineName = data['displayname'];
    this.pipelineGUID = data.id;
    this.interfacePipelineDisplayname = this.pipelineName + "(" + this.pipelineGUID + ")";
    this.backupInterfacePipelineDisplayname = this.interfacePipelineDisplayname;
    const validationModalRef = this.modalService.open(content,
      { windowClass: "ValidationPopupScreen", backdrop: 'static', keyboard: false });
    this.trackModalRef(validationModalRef, "ValidationPopupScreen");
    
    validationModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(validationModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(validationModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }

  //The below method will fetch the record from ValidationMaster table and stores the data into InterfaceValidationHistory
  getInterfaceValidationHistoryInfo() {
    this.ngxUiLoaderService.start();
    this.service.GetInterfaceValidationHistory().subscribe((data: any) => {
      console.log(data);
      this.ngxUiLoaderService.stop();
      this.InterfaceValidationHistory = data;
      for (let i = 0; i < this.InterfaceValidationHistory.length; i++) {
        this.InterfaceValidationHistory[i].FromDate = this.InterfaceValidationHistory[i].FromDate.split(" ")[0];
        this.InterfaceValidationHistory[i].ToDate = this.InterfaceValidationHistory[i].ToDate.split(" ")[0];
      }
      this.InterfaceValidationHistory.sort((a, b) => {
        if (a.Status === 'In-Progress' && b.Status !== 'In-Progress') {
          return -1; // a comes before b
        } else if (a.Status !== 'In-Progress' && b.Status === 'In-Progress') {
          return 1; // a comes after b
        } else {
          return 0; // preserve original order
        }
      });

      this.searchtextData = this.pipelineName;
      this.getFilter();
    }, error => {
      this.toastr.error("Unable to fetch pipeline details", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.InterfaceValidationHistory = []
      console.error(error);
      this.ngxUiLoaderService.stop();
    });
  }

  private buildDefaultDeliveryRules(intlist: any): any[] {
    const sourceGuid = intlist['SEGUID'] || intlist['SourceAccountGuid'] || intlist['SourceGUID'] || intlist['sourceGuid'] || '';
    const targetGuid = intlist['DEGUID'] || intlist['TargetAccountGuid'] || intlist['TargetGUID'] || intlist['targetGuid'] || '';
    const sourceEntityType = intlist['SETYPE'] || intlist['SourceEntityType'] || intlist['sourceEntityType'] || 'Facility';
    const targetEntityType = intlist['DETYPE'] || intlist['TargetEntityType'] || intlist['targetEntityType'] || 'Laboratory';
    const sourceTypeName = intlist['SourceTypeName'] || intlist['sourceTypeName'] || 'Account';
    const targetTypeName = intlist['TargetTypeName'] || intlist['targetTypeName'] || 'Account';

    const RuleConfigRequest: any[] = [
      {
        "Type": "SE",
        "EntityType": sourceEntityType,
        "TypeName": sourceTypeName,
        "Guid": sourceGuid || ""
      }
    ];

    if (targetGuid && targetGuid !== sourceGuid) {
      RuleConfigRequest.push({
        "Type": "DE",
        "EntityType": targetEntityType,
        "TypeName": targetTypeName,
        "Guid": targetGuid
      });
    }

    return RuleConfigRequest;
  }

  private parseRuleConfig(configData: any): any {
    if (typeof configData === 'string') {
      configData = JSON.parse(configData);
    }

    if (configData && typeof configData === 'object' && configData['RuleConfig']) {
      const nestedConfig = configData['RuleConfig'];
      return typeof nestedConfig === 'string' ? JSON.parse(nestedConfig) : nestedConfig;
    }

    return configData;
  }

  private validateExistingRules(savedRuleConfig: any): boolean {
    if (!Array.isArray(savedRuleConfig) || savedRuleConfig.length === 0) {
      return false;
    }

    const firstRule = savedRuleConfig[0];
    return firstRule &&
      Array.isArray(firstRule.rules) &&
      firstRule.rules.length > 0 &&
      typeof firstRule.ruleSatisfaction === 'string';
  }

  private extractRuleConfigFromResponse(resp: any): { savedRuleConfig: any, hasExistingRules: boolean } {
    if (!resp?.DeliveryRuleConfig) {
      return { savedRuleConfig: null, hasExistingRules: false };
    }

    try {
      let configData = resp['DeliveryRuleConfig'];
      let savedRuleConfig = this.parseRuleConfig(configData);

      if (savedRuleConfig && !Array.isArray(savedRuleConfig)) {
        savedRuleConfig = [savedRuleConfig];
      }

      const hasExistingRules = this.validateExistingRules(savedRuleConfig);
      return { savedRuleConfig, hasExistingRules };
    } catch (error) {
      return { savedRuleConfig: null, hasExistingRules: false };
    }
  }

  private async saveDeliveryRuleConfig(result: any, uniqueId: string, routeId: string): Promise<void> {
    this.ngxUiLoaderService.start();
    try {
      const saveResp = await this.service.postapi('api/Routes/InsertAndUpdateDeliveryRuleConfig', {
        "RuleConfig": JSON.stringify(result),
        "UniqueID": uniqueId,
        "RouteID": routeId,
        "ModifierID": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      });

      if (saveResp) {
        this.toastr.success("RuleConfig saved successfully", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
      } else {
        this.toastr.error("Unable to update RuleConfig", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
      }
    } finally {
      this.ngxUiLoaderService.stop();
    }
  }

  /**
   * Saves Delivery RuleConfig using InsertAndUpdateRuleConfig (usp_InsertAndUpdateRuleConfig).
   * Uses version from dropdown (result._versionMeta) when the rule config dialog returns it;
   * otherwise falls back to Version 1 / Delivered.
   
  private async saveDeliveryRuleConfig(result: any, uniqueId: string, routeId: string): Promise<void> {
    this.ngxUiLoaderService.start();debugger
    try {
      const meta = result?._versionMeta;
      const targetVersion: number = meta?.selectedVersion != null
        ? (parseInt(String(meta.selectedVersion), 10) || 1)
        : 1;
      const targetStatus = (meta?.selectedVersionStatus ?? 'Delivered').toString().trim() || 'Delivered';

      // Use array slice to exclude _versionMeta when stringifying rule config
      const cleanPayload = Array.isArray(result) ? result.slice() : (result?.ruleConfig ?? result);

      const body = {
        RouteUniqueId: uniqueId,
        RuleConfig: JSON.stringify(cleanPayload ?? result),
        MessageStatus: 'Delivered',
        Version: targetVersion,
        VersionStatus: targetStatus,
        IsLive: false
      };

      await new Promise<void>((resolve, reject) => {
        this._ruleEngineService.InsertAndUpdateRuleConfig(body).subscribe({
          next: () => {
            this.toastr.success("RuleConfig saved successfully", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
            resolve();
                
            if(targetStatus.toLowerCase() == "live"){
              this.getAllTheCache(this.routeGuid);
            }
          },
          error: () => {
            this.toastr.error("Unable to update RuleConfig", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            reject();
          }
        });
      });
      
    } catch (err) {
      this.toastr.error("Unable to update RuleConfig", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    } finally {
      this.ngxUiLoaderService.stop();
    }
  }*/

  /**
   * Opens Delivery Mapping dialog using GetRuleConfigVersions with messageStatus: 'Delivered'.
   * Replaces the previous GetDeliveryRuleConfig flow with version-based rule config.
   */
  private normalizeTestOrgFlagValue(value: unknown): string {
    return value != null && String(value).trim() === '1' ? '1' : '0';
  }

  private getTestOrganizationFlagsForChildDialogs(): {
    sourceIsTestOrganization: string;
    destinationIsTestOrganization: string;
  } {
    return {
      sourceIsTestOrganization: this.sourceIsTestOrganization || '0',
      destinationIsTestOrganization: this.destinationIsTestOrganization || '0',
    };
  }

  private entityMatchesGuidForTestOrg(item: any, entityGuid: string): boolean {
    const targetGuid = (entityGuid || '').toString().trim().toLowerCase();
    if (!targetGuid) {
      return false;
    }
    const candidateGuids = [
      item?.LocationGUID,
      item?.locationGUID,
      item?.orgguid,
      item?.orgGUID,
      item?.entityguid,
      item?.EntityGUID,
    ];
    return candidateGuids.some((guid) => (guid || '').toString().trim().toLowerCase() === targetGuid);
  }

  private resolveTestOrganizationFromSearchResults(list: any[], entityGuid: string): string {
    if (!list?.length || !entityGuid) {
      return '0';
    }
    const matchingEntities = list.filter((item: any) => this.entityMatchesGuidForTestOrg(item, entityGuid));
    if (!matchingEntities.length) {
      return '0';
    }
    const isTest = matchingEntities.some((item: any) =>
      this.normalizeTestOrgFlagValue(item?.istestorganization) === '1'
    );
    return isTest ? '1' : '0';
  }

  private toEntitySearchList(response: any): any[] {
    return Array.isArray(response) ? response : (response?.data || []);
  }

  async ensureTestOrganizationFlagsLoaded(
    sourceGuid?: string,
    destinationGuid?: string
  ): Promise<void> {
    const seguid = (sourceGuid || this.selectedSourceEntityguid || '').toString().trim();
    const deguid = (destinationGuid || this.selectedTargetEntityguid || '').toString().trim();
    if (!seguid || !deguid) {
      return;
    }
    if (
      this.testOrgFlagsLoadedForSourceGuid === seguid &&
      this.testOrgFlagsLoadedForDestGuid === deguid &&
      this.sourceIsTestOrganization !== '' &&
      this.destinationIsTestOrganization !== ''
    ) {
      return;
    }

    try {
      const response: any = await firstValueFrom(
        forkJoin({
          source: this.service.GetAccountNamesListAsync({ lsearch: seguid, lSearch: seguid }),
          destination: this.service.GetAccountNamesListAsync({ lsearch: deguid, lSearch: deguid }),
        })
      );
      this.sourceIsTestOrganization = this.resolveTestOrganizationFromSearchResults(
        this.toEntitySearchList(response?.source),
        seguid
      );
      this.destinationIsTestOrganization = this.resolveTestOrganizationFromSearchResults(
        this.toEntitySearchList(response?.destination),
        deguid
      );
    } catch {
      this.sourceIsTestOrganization = '0';
      this.destinationIsTestOrganization = '0';
    }
    this.testOrgFlagsLoadedForSourceGuid = seguid;
    this.testOrgFlagsLoadedForDestGuid = deguid;
  }

  async openDeliveryMapping(intlist: any): Promise<void> {
    // debugger
    try {
      const routeId = intlist['id'];
      const uniqueId = intlist['UniqueID'];
      const routeName = intlist['displayname'] || '';
      const deliveryTemplateKey = this.getPreDeliveryTemplateKey(intlist);

      this.ngxUiLoaderService.start();
      const raw = await this._ruleEngineService.GetRuleConfigVersions(uniqueId, 'Delivered').toPromise();
      this.ngxUiLoaderService.stop();

      const list = Array.isArray(raw) ? raw : [];
      const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
      // No saved delivery rules: open with an empty rule list - do not inject SE/DE master rules by default.
      const finalRuleData = hasExistingRules?ruleData : [];//this.buildDefaultDeliveryRules(intlist);

      const sourceGuid = intlist['SEGUID'] || intlist['SourceAccountGuid'] || intlist['SourceGUID'] || intlist['sourceGuid'] || '';
      const targetGuid = intlist['DEGUID'] || intlist['TargetAccountGuid'] || intlist['TargetGUID'] || intlist['targetGuid'] || '';

      await this.ensureTestOrganizationFlagsLoaded(sourceGuid, targetGuid);

      this.dialog.open(RuleConfigComponentComponent, {
        maxWidth: '95vw',
        height: '96%',
        width: '100%',
        data: {
          data: finalRuleData,
          isView: hasExistingRules,
          routeGuid: routeId,
          routeName,
          routeUniqueID: uniqueId,
          ruleExecutionStage: 'Delivered',
          componentname: 'interface',
          dialogTitle: 'Pre-Delivery Validation Rules',
          deliveryTemplateKey,
          ...this.getTestOrganizationFlagsForChildDialogs(),
        },
        autoFocus: false,
        disableClose: true,
        panelClass: 'rule-config-dialog-container'
      });

      // const result = await dialogRef.afterClosed().toPromise();
      // if (result) {
      //   await this.saveDeliveryRuleConfig(result, uniqueId, routeId);
      // }
    } catch (err) {
      this.ngxUiLoaderService.stop();
      this.toastr.error("An unexpected error occurred", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }

  private isInboundPipeline(intlist: any): boolean {
    const direction = String(intlist?.Direction ?? '').toLowerCase();
    return direction.includes('inbound');
  }

  private isOutboundPipeline(intlist: any): boolean {
    const direction = String(intlist?.Direction ?? '').toLowerCase();
    return direction.includes('outbound');
  }

  /** Pre-Validation: inbound â†’ HL7; outbound â†’ XML (AP/CP). */
  private getPreValidationTemplateKey(intlist: any): string {
    return this.isInboundPipeline(intlist) ? 'RESULT_OUTBOUND' : 'DEFAULT';
  }

  /** Pre-Delivery: outbound â†’ HL7; inbound â†’ XML (AP/CP). */
  private getPreDeliveryTemplateKey(intlist: any): string {
    return this.isOutboundPipeline(intlist) ? 'RESULT_OUTBOUND' : 'DEFAULT';
  }

  /** Live CoreConfig from GetMappings/Get?prevalidation=true response. */
  private getLiveCoreConfigFromMappingsResponse(response: any): any {
    const list = response?.CoreConfigVersionList;
    if (!Array.isArray(list)) {
      return null;
    }
    return list.find((c: any) => c?.islive === true) ?? null;
  }

  /**
   * Strict verification: legacy pre-validation exists (not transform xslconfig).
   * Used for routing and toggle guard ? do not use top-level response.mappedxml.
   */
  private hasLegacyValidationConfig(response: any): boolean {
    const live = this.getLiveCoreConfigFromMappingsResponse(response);
    const vc = live?.json?.processorconfig?.validationconfig;
    if (!vc) {
      return false;
    }
    const mappedxml = (vc.mappedxml ?? '').toString().trim();
    const generatedxsl = (vc.generatedxsl ?? '').toString().trim();
    return !!(mappedxml || generatedxsl);
  }

  /** Opens Pre-Validation Rule Config dialog (mirrors openDeliveryMapping). */
  async openPreValidationRuleConfig(intlist: any): Promise<void> {
    try {
      const routeId = intlist['id'];
      const uniqueId = intlist['UniqueID'];
      const routeName = intlist['displayname'] || '';
      const deliveryTemplateKey = this.getPreValidationTemplateKey(intlist);

      this.ngxUiLoaderService.start();
      const raw = await this._ruleEngineService.GetRuleConfigVersions(uniqueId, 'PreValidation').toPromise();
      this.ngxUiLoaderService.stop();

      const list = Array.isArray(raw) ? raw : [];
      const { ruleData, hasExistingRules } = this.extractRuleConfigFromVersions(list);
      const finalRuleData = hasExistingRules ? ruleData : [];

      const sourceGuid = intlist['SEGUID'] || intlist['SourceAccountGuid'] || intlist['SourceGUID'] || intlist['sourceGuid'] || '';
      const targetGuid = intlist['DEGUID'] || intlist['TargetAccountGuid'] || intlist['TargetGUID'] || intlist['targetGuid'] || '';
      await this.ensureTestOrganizationFlagsLoaded(sourceGuid, targetGuid);

      this.dialog.open(RuleConfigComponentComponent, {
        maxWidth: '95vw',
        height: '96%',
        width: '100%',
        data: {
          data: finalRuleData,
          isView: hasExistingRules,
          routeGuid: routeId,
          routeName,
          routeUniqueID: uniqueId,
          ruleExecutionStage: 'PreValidation',
          componentname: 'interface',
          dialogTitle: 'Pre-Validation Rules',
          deliveryTemplateKey,
          ...this.getTestOrganizationFlagsForChildDialogs(),
        },
        autoFocus: false,
        disableClose: true,
        panelClass: 'rule-config-dialog-container'
      });
    } catch {
      this.ngxUiLoaderService.stop();
      this.toastr.error('An unexpected error occurred', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
    }
  }

  /** Opens legacy XmlmappingsComponent for pre-validation (keeps transform mappedxml display fallback). */
  private async openLegacyValidationMappingModal(dataitem: any, response: any): Promise<void> {
    const sourceGuid = dataitem?.SEGUID || dataitem?.SourceAccountGuid || dataitem?.sourceGuid || '';
    const targetGuid = dataitem?.DEGUID || dataitem?.TargetAccountGuid || dataitem?.targetGuid || '';
    await this.ensureTestOrganizationFlagsLoaded(sourceGuid, targetGuid);
    this.Templatearray = response as any;
    const coreConfigVersionList = this.Templatearray['CoreConfigVersionList'];
    const liveConfig = this.getLiveCoreConfigFromMappingsResponse(response);
    if (liveConfig?.json?.processorconfig?.validationconfig?.mappedxml) {
      this.mappedXml = liveConfig.json.processorconfig.validationconfig.mappedxml;
    } else {
      this.mappedXml = this.Templatearray['mappedxml'];
    }
    this.dataToModal = {
      templateid: this.Templatearray['template'],
      templatelist: this.Templatearray['templatelist'],
      MappedXml: this.mappedXml,
      resultJson: this.Templatearray['resultjson'],
      routeid: dataitem.id,
      processorid: dataitem.PAID,
      processorapikey: dataitem.PAAPIKEY,
      routeName: dataitem.displayname,
      ProcessorName: dataitem.PANAME,
      uniqueid: dataitem.UniqueID,
      routedetails: this.Templatearray['routeDetails'],
      CoreConfigVersionList: coreConfigVersionList,
      lockXMLmap: dataitem.IsLocked !== undefined && dataitem.IsLocked == 'True' ? dataitem.IsLocked : false,
      isValidation: true,
      componentname: 'interface',
      ...this.getTestOrganizationFlagsForChildDialogs(),
    };

    if (this.Templatearray['mappedxml'] != null) {
      const validationMappingModalRef = this.modalService.open(XmlmappingsComponent,
        { windowClass: 'myCustomModalClasscreatexml', backdropClass: 'xmlmappings-backdrop', backdrop: 'static', keyboard: false });
      validationMappingModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
      this.trackModalRef(validationMappingModalRef, 'myCustomModalClasscreatexml');

      validationMappingModalRef.result.then(
        () => {
          this.modalWasOpen = false;
          this.untrackModalRef(validationMappingModalRef);
        },
        () => {
          this.modalWasOpen = false;
          this.untrackModalRef(validationMappingModalRef);
        }
      );

      setTimeout(() => {
        const modalElement = document.querySelector('.modal.show') as HTMLElement;
        if (modalElement) {
          modalElement.setAttribute('data-interface-modal', 'true');
        }
        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
        if (backdrop) {
          backdrop.setAttribute('data-interface-modal', 'true');
        }
      }, 100);

      this.modalWasOpen = true;
    } else {
      this.modalService.dismissAll();
      this.toastr.error('Template configurations not found', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  /**
   * Extracts rule config from GetRuleConfigVersions response.
   * Uses the latest version's RuleConfig when available.
   */
  private extractRuleConfigFromVersions(list: any[]): { ruleData: any; hasExistingRules: boolean } {
    if (!list || list.length === 0) {
      return { ruleData: null, hasExistingRules: false };
    }
    const latest = list[list.length - 1];
    const configData = latest?.RuleConfig ?? latest?.ruleConfig;
    if (!configData) {
      return { ruleData: null, hasExistingRules: false };
    }
    const savedRuleConfig = this.parseRuleConfig(configData);
    if (!savedRuleConfig) {
      return { ruleData: null, hasExistingRules: false };
    }
    const asArray = Array.isArray(savedRuleConfig) ? savedRuleConfig : [savedRuleConfig];
    const hasExistingRules = this.validateExistingRules(asArray);
    return { ruleData: asArray, hasExistingRules };
  }

  // async openDeliveryMappingOld(intlist: any): Promise<void> {
  //   debugger;
  //   try {
  //     const routeId = intlist['id'] || this.selectedrouteId;
  //     const uniqueId = intlist['UniqueID'] || this.UniqueID;
  //     const routeName = intlist['displayname'] || '';
  //     const resp = await this.service.postapi('api/Routes/GetDeliveryRuleConfig', { "UniqueID": uniqueId });
  //     const { savedRuleConfig, hasExistingRules } = this.extractRuleConfigFromResponse(resp);
  //     const ruleData = hasExistingRules ? savedRuleConfig : [];

  //     // componentname is required so Rule Builder can load Send To QC / Approve role permissions from session role menus.
  //     const dialogRef = this.dialog.open(RuleConfigComponentComponent, {
  //       maxWidth: '95vw',
  //       height: '96%',
  //       width: '100%',
  //       data: {
  //         data: ruleData,
  //         isView: hasExistingRules,
  //         routeGuid: routeId,
  //         routeName: routeName,
  //         routeUniqueID: uniqueId,
  //         ruleExecutionStage: 'Delivered',
  //         componentname: 'interface',
  //       },
  //       autoFocus: false,
  //       disableClose: true,
  //       panelClass: 'rule-config-dialog-container',
  //     });
  //     const result = await dialogRef.afterClosed().toPromise();
  //     if ((result as any)?.isCloseButtonClicked === false) {
  //       await this.saveDeliveryRuleConfig(result, uniqueId, routeId);
  //     }
  //   } catch (err) {
  //     this.ngxUiLoaderService.stop();
  //     this.toastr.error("An unexpected error occurred", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
  //   }
  // }

  checkValidationMasterExists(reValidation) {
    let filtereddata: any;

    if (this.InterfaceValidationHistory[0].FromDate.includes("/")) {
      filtereddata = this.InterfaceValidationHistory.filter(va => va.PipelineName == this.pipelineName &&
        va.PipelineGUID == this.pipelineGUID
        && va.FromDate == (this.datepipe.transform(this.selectedFromDate, 'MM/dd/yyyy')).toString().replace(/\b0/g, '')
        && va.ToDate == (this.datepipe.transform(this.selectedToDate, 'MM/dd/yyyy')).toString().replace(/\b0/g, '')
        && va.Status == 'In-Progress');
    } else {
      filtereddata = this.InterfaceValidationHistory.filter(va => va.PipelineName == this.pipelineName &&
        va.PipelineGUID == this.pipelineGUID
        && va.FromDate == (this.datepipe.transform(this.selectedFromDate, 'dd-MM-yyyy')).toString()
        && va.ToDate == (this.datepipe.transform(this.selectedToDate, 'dd-MM-yyyy')).toString()
        && va.Status == 'In-Progress');
    }
    if (filtereddata.length > 0) {
      this.toastr.success("Data Validation is In-Progress for the selected date range", " ", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    else {
      if (this.InterfaceValidationHistory[0].FromDate.includes("/")) {
        filtereddata = this.InterfaceValidationHistory.filter(va => va.PipelineName == this.pipelineName &&
          va.PipelineGUID == this.pipelineGUID
          && va.FromDate == (this.datepipe.transform(this.selectedFromDate, 'MM/dd/yyyy')).toString().replace(/\b0/g, '')
          && va.ToDate == (this.datepipe.transform(this.selectedToDate, 'MM/dd/yyyy')).toString().replace(/\b0/g, '')
          && va.Status == 'completed');
      } else {
        filtereddata = this.InterfaceValidationHistory.filter(va => va.PipelineName == this.pipelineName &&
          va.PipelineGUID == this.pipelineGUID
          && va.FromDate == (this.datepipe.transform(this.selectedFromDate, 'dd-MM-yyyy')).toString()
          && va.ToDate == (this.datepipe.transform(this.selectedToDate, 'dd-MM-yyyy')).toString()
          && va.Status == 'completed');
      }
      if (filtereddata.length > 0) {
        //calling revalidation method
        this.filteredInterfaceRevalidationData = filtereddata;
        this.reValidation(reValidation);
        return false;
      } else
        return true;
    }
  }
  isDateRangeValid(): boolean {

    let isactie = false;
    let today = new Date()
    if (today >= this.selectedFromDate && today >= this.selectedToDate) {
      if (this.selectedFromDate <= this.selectedToDate) {
        return true
      }
    }
    return isactie
  }
  //sends the selected interface information to the ValidationMaster table and then to topic
  sendDataForDataValidation(reValidation) {
    let requestBody;
    if (this.calculateDiff() < 7) {
      if (this.checkValidationMasterExists(reValidation)) {
        requestBody = {
          PipelineGUID: this.pipelineGUID,
          PipelineName: this.pipelineName,
          FromDate: this.selectedFromDate == undefined ? '' : this.datepipe.transform(this.selectedFromDate, 'yyyy-MM-dd') + ' 00:00:00',
          ToDate: this.selectedToDate == undefined ? '' : this.datepipe.transform(this.selectedToDate, 'yyyy-MM-dd') + ' 23:59:59',
          Generated_By: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
          Status: 'In-Progress'
        };
        this.service.InsertInterfaceValidationHistory(requestBody).subscribe((ReturnResponse: any) => {
          if (ReturnResponse.status == "Success") {
            this.toastr.success("Successfully sent interface information for Data Validation, it might take few minutes to process the validation.", " ", {
              timeOut: 500,
              positionClass: 'toast-bottom-right'
            });
          } else {
            console.log("sendDataForDataValidation() returnResponse from validationmaster insertion:: " + JSON.stringify(ReturnResponse));
          }
        }, (error) => {
          console.error("sendDataForDataValidation() error occured :: " + error);
          this.service.copyableToastError(error);
        });
      }
    }
    else {
      this.toastr.error("Date range should not exceed 7 days", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  sendDataForDataValidationTopic(requestBody: any) {
    this.ngxUiLoaderService.start();
    this.service.sendToTopic(requestBody).subscribe((response: any) => {
      this.ngxUiLoaderService.stop();
      console.log(response);
      this.getInterfaceValidationHistoryInfo();
    });
  }

  calculateDiff() {

    let todayDate = new Date(this.selectedToDate);
    let sentOnDate = new Date(this.selectedFromDate);
    sentOnDate.setDate(sentOnDate.getDate());
    let differenceInTime = todayDate.getTime() - sentOnDate.getTime();
    // To calculate the no. of days between two dates
    let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
    return differenceInDays;
  }

  reValidation(reValidation) {
    this.modalReference = this.modalService.open(reValidation,
      { windowClass: "ReValidationPopupScreen", backdrop: 'static', keyboard: false });
    this.trackModalRef(this.modalReference, "ReValidationPopupScreen");
    
    this.modalReference.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(this.modalReference);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(this.modalReference);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }

  //Checks the status of the validationmaster entry
  isCompletedStatus(status: string): boolean {
    return status === 'completed';
  }

  //onClick of each validationmaster row entry the below method will get called and fetches record from the entitysearch table
  displayInterfaceValidationList(item: any) {


    // this.backupPipelineName = item['PipelineName'];
    // this.backupPipelineGUID = item.PipelineGUID;
    this.pipelineName = item['PipelineName'];
    this.pipelineGUID = item.PipelineGUID;
    // this.fromdate=item.FromDate;
    // this.todate=item.toDate;


    this.interfacePipelineDisplayname = '';
    setTimeout(() => {
      this.interfacePipelineDisplayname = item.PipelineName + "(" + item.PipelineGUID + ")";
    })


    this.getResponseDatabyMessageIdInfo(item);
  }

  transformDate(value: any) {
    if (value !== undefined) {
      let dates = value.split("-");
      if (dates.length > 0) {
        value = dates[1] + '-' + dates[0] + '-' + dates[2]
      }
      return value;

    }
  }

  //Fetches record from entitysearch table against pipelineguid
  getResponseDatabyMessageIdInfo(item: any) {
    let fromDate;
    let toDate;
    this.ngxUiLoaderService.start();
    this.callingComponent = 'Interface'
    if (item.FromDate.includes("/")) {
      fromDate = this.datepipe.transform(item.FromDate, 'yyyy-MM-dd');
      toDate = this.datepipe.transform(item.ToDate, 'yyyy-MM-dd');
    }
    else {
      fromDate = this.transformDate(item.FromDate);
      toDate = this.transformDate(item.ToDate);
    }
    this.service.GetDatabyMessageIdInfo(item.PipelineGUID, fromDate + ' 00:00:00', toDate + ' 23:59:59').subscribe((result: any) => {
      console.log(result);
      this.ngxUiLoaderService.stop();
      if (result.length > 0) {

        this.showInterfaceData = true;

        setTimeout(() => {
          this.interfacePipelineDisplayname = this.pipelineName + "(" + this.pipelineGUID + ")";
        })
        for (let i = 0; i < result.length; i++) {
          let ovj = {
            "Accession": null,
            "Order": null,
            "DateofBirth": null,
            "PatientName": null,
            "MessageId": null
          }
          result[i] = Object.assign(ovj, result[i]);

        }
        this.dataSources = result;
        console.log("datasource value is " + JSON.stringify(this.dataSources));
        this.selectedCard(this.dataSources[0], 0);
        this.responseLength = result.length;

      }
      else {
        this.ngxUiLoaderService.stop();
        this.toastr.error("No messages were found for data validation", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }, (error) => {
      this.ngxUiLoaderService.stop();
    });
  }

  //Calls GetInterfaceMessageDataByMessageId method and displays the validation data of particular message
  selectedCard(item: any, index: number) {
    this.selectedCardIndex = index;
    this.GetInterfaceMessageDataByMessageId(item);
  }

  //For a particular selected message gets the data validation response from messagevalidation table and shows the difference
  GetInterfaceMessageDataByMessageId(item) {
    let messageid = item.MessageId;
    this.ngxUiLoaderService.start();
    this.service.GetMessageDataByMessageId(messageid).subscribe((result: any) => {
      this.ngxUiLoaderService.stop();
      console.log(result);
      if (result[0] !== undefined) {
        this.validatedDataResponse = JSON.parse(result[0].StatusMessage);
      }
      else {
        this.validatedDataResponse = [];
      }
    });
  }

  //The below method is used for search of interface validation history data
  getFilter() {
    this.tripfilter.PipelineName = this.searchtextData;
    this.tripfilter.Fromdate = this.searchtextData;
    this.tripfilter.Todate = this.searchtextData;
    this.tripfilter.Generated_By = this.searchtextData;
    this.tripfilter.Generated_On = this.searchtextData;
    this.tripfilter.Status = this.searchtextData;
  }

  //The below method is used for search of  selectedcard data(Accession#,Order#,patientname)
  getFilterDetails() {
    this.cardfilter.Accession = this.searchData;
    this.cardfilter.Order = this.searchData;
    this.cardfilter.PatientName = this.searchData;
    this.cardfilter.DateofBirth = this.searchData;
  }

  //The below method will be called when clicked on the back button, and loads the data
  loadInterfaceDataValidationScreen() {
    this.ngxUiLoaderService.start();
    this.showInterfaceData = false;
    this.interfacePipelineDisplayname = this.backupInterfacePipelineDisplayname;
    this.responseLength = 0;
    this.searchData = '';
    this.getFilter();
    this.getFilterDetails();
    this.ngxUiLoaderService.stop();
  }

  performRevalidation() {
    let requestBody;
    let fromdate;
    let todate;
    fromdate = this.selectedFromDate == undefined ? '' : this.datepipe.transform(this.selectedFromDate, 'yyyy-MM-dd') + ' 00:00:00';
    todate = this.selectedToDate == undefined ? '' : this.datepipe.transform(this.selectedToDate, 'yyyy-MM-dd') + ' 23:59:59';
    this.ngxUiLoaderService.start();
    this.service.DeleteInterfaceValidatedMessages(this.pipelineGUID, fromdate, todate)
      .pipe(
        // Handle first message
        map((message) => requestBody = {
          "Id": this.filteredInterfaceRevalidationData[0].Id,
          "PipelineGUID": this.filteredInterfaceRevalidationData[0].PipelineGUID,
          "Generated_By": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
          "Generated_On": new Date().toString(),
          "Status": "In-Progress"
        })

        // Trigger second call and handle data
        , mergeMap(() => this.service.UpdateValidationMaster(requestBody).pipe(catchError(() => of('There was an error but I fixed it!'))))
        , map((message) => requestBody = {
          fromDate: this.selectedFromDate == undefined ? '' : this.datepipe.transform(this.selectedFromDate, 'yyyy-MM-dd') + ' 00:00:00',
          toDate: this.selectedToDate == undefined ? '' : this.datepipe.transform(this.selectedToDate, 'yyyy-MM-dd') + ' 23:59:59',
          pipelineGUID: this.pipelineGUID,
        })

        // // Trigger third call and handle data
        // , mergeMap(() => this.service.sendToTopic(requestBody))
        // , map((message) => console.log(message))
      ).subscribe(data => {
        console.log('Chain executed successfully. Good job :)')
        this.toastr.success("Successfully sent interface information for Data Validation, it might take few minutes to process the validation.", " ", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        })
        this.modalReference.close();
        this.getInterfaceValidationHistoryInfo();
        this.ngxUiLoaderService.stop();

      }, error => {
        this.ngxUiLoaderService.stop();
        console.error(error);
      })
  }

  dismissRevalidation(content: any) {
    this.modalReference.close();
    this.filteredInterfaceRevalidationData = [];
  }

  // changeDateFormat(givendate) {
  //   if (givendate.includes("-")) {
  //     let datearray = givendate.split("-")
  //     if (datearray.length > 0) {
  //       return datearray[1] + '-' + datearray[0] + '-' + datearray[2]
  //     }
  //   } else {
  //     return givendate;
  //   }
  // }
  openFTPfilespopup() {
    const dataToFTPFilesModal = {
      routeId: this.selectedRoutGUID,
      sourceagent: this.pipeLineDetails['SourceAgentid'],
      name: this.selectedRouteName,
      uniqid: this.isselect,
      selectflag: false
    };
    const ftpModalRef = this.modalService.open(FtpfilesComponent,
      { windowClass: "myCustomModalClassFTP", backdrop: 'static', keyboard: false });
    ftpModalRef.componentInstance.inputDataInModalComponent = dataToFTPFilesModal;
    this.trackModalRef(ftpModalRef, "myCustomModalClassFTP");
    
    ftpModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(ftpModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(ftpModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }


  viewpassword() {

    if (this.isviewpassword) {
      this.service.auditsave("Add", "", "Viewed FTP password for pipeline :- " + this.pipeLineDetails['DisplayName'], "Pipeline", this.isselect, "Viewed Password (CIIS)");
    }
  }

  getPageDetails(event: { pageIndex: number; pageSize: number }) {
    if (event.pageIndex == 0) {
      this.pagenumber = 1;
    } else {
      this.pagenumber = event.pageIndex + 1;
    }

    this.PageSize = 15
    this.global?this.onSearch(this.selectedGS,this.pagenumber,this.CallBySearchBar): this.getpipelinelist(false, true);
  }
  failuresearchbydate() {
    if(this.issuccessmsgpop=='view'){
      this.getsuccessmsglist('');
    }else{
      let retval = this.GetDatewiseFailureReasonList(true);
    }
  }
  async clearnotepopupvalues(){
    this.failedMessageNote='';
  }

  async closenote(h) {
    await this.clearnotepopupvalues();
    h('close modal');
  }

  async saveNoteReprocess(h){
    this.ngxUiLoaderService.start();
    let checkedids = ""
    this.failurereason.forEach(V => {
      if (V['ischecked'] == true) {
        checkedids += V['MessageRefernceId'] + ','
      }
    })
    checkedids != '' ? checkedids.slice(0, -1) : checkedids;
    var datacons ={
      "messagerefernceid" : checkedids,
      "note" : this.failedMessageNote,
      "action" : "Reprocessed",
      "modifiedby" : JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    }
    this.messagereprocessdata.push(datacons);
      this.service.reprocessBymsgID(this.messagereprocessdata).subscribe((response: any) => {
        if (response['status'].toLowerCase() == 'success')
        {
          this.closenote(h);
          this.service.showAsyncStatusUpdateToast('reprocess');
          this.isopenpopup=false;
          if(this.issuccessmsgpop!==''){
          this.getsuccessmsglist(null);
          }else{
            this.failurerespopup(this.failurereasondata, false, null);
          }
          //this.getpipelinedetails({ 'UniqueID': this.isselect }, 'pop');
          //this.closepopup(h);
        }
        else
        {
          //this.closepopup(h);
          this.toastr.error("Failed", "Reprocess", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
        this.ngxUiLoaderService.stop();
    })
  }

  async saveNoteReprocess1(h, closeAfterSave: boolean = false){
    this.ngxUiLoaderService.start();
    let checkedids = ""
    this.failurereason.forEach(V => {
      if (V['ischecked'] == true) {
        checkedids += V['MessageRefernceId'] + ','
      }
    })
    checkedids != '' ? checkedids.slice(0, -1) : checkedids;
    var datacons ={
      "messagerefernceid" : checkedids,
      "note" : this.failedMessageNote,
      "action" : "Reprocessed",
      "modifiedby" : JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    }
    this.messagereprocessdata.push(datacons);
      this.service.reprocessBymsgID(this.messagereprocessdata).subscribe((response: any) => {
        if (response['status'].toLowerCase() == 'success')
        {
          if (closeAfterSave) {
            this.closenote(h);
            this.closepopup(h);
          }
          this.service.showAsyncStatusUpdateToast('reprocess');
          this.getpipelinedetails({ 'UniqueID': this.isselect }, 'pop');
          this.closepopup(h);
        }
        else
        {
          this.closepopup(h);
          this.toastr.error("Failed", "Reprocess", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
        this.ngxUiLoaderService.stop();
    })
  }
  getsuccessmsglist(failurerespopup){
    let obj={
      "UniqueID": this.isselect,
      "FromDate":  this.fromdatepop!=''?this.fromdatepop + ' 00:00:00':null,
      "ToDate":this.todatepop!=''?this.todatepop + ' 23:59:59':null
    }
    this.ngxUiLoaderService.start();
    this.service.GetSuccessMessageList(obj).subscribe((data) => {
      if (data['status'].toLowerCase() == 'success') {
        this.isheaderchecked = false;
        let resbody=JSON.parse(data['responsebody']);
        if(this.issuccessmsgpop==''){
        this.successmsglist=resbody==null ||resbody==''?[]:resbody;
        }
        if(this.fromdatepop==''){
          let date: Date = new Date();
          date.setDate(date.getDate() - 6);
          this.fromdatepop = this.datepipe.transform(date, 'yyyy-MM-dd');
          this.todatepop = this.todaydate;
        }
        if(this.issuccessmsgpop=='view'){
          this.ngxUiLoaderService.stop();
          this.failurereason = resbody==null?[]:resbody
          this.failurereasonBackup = this.failurereason
          if(this.isopenpopup){
            this.isopenpopup=false;
            const successMsgModalRef = this.modalService
        .open(failurerespopup, {
          windowClass: "failuremsgpop",
          backdrop: "static",
          keyboard: false,
        });
            this.currentModalRefs.push(successMsgModalRef);
            
            successMsgModalRef.result.then(
              (result) => {
                this.modalWasOpen = false;
                this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== successMsgModalRef);
              },
              (reason) => {
                this.modalWasOpen = false;
                this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== successMsgModalRef);
              }
            );
            
            // Add data attribute to identify the modal and backdrop
            setTimeout(() => {
              const modalElement = document.querySelector('.modal.show') as HTMLElement;
              if (modalElement) {
                modalElement.setAttribute('data-interface-modal', 'true');
              }
              const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
              if (backdrop) {
                backdrop.setAttribute('data-interface-modal', 'true');
              }
            }, 100);
            
            this.modalWasOpen = true;
          }
        }
        
      }
    }), error => {
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    }
  }

  vbdiagnostic(){
    let obj={
      "AgentId": this.pipeLineDetails['SourceAgentid'],
      "JobId": this.jobid.length>0 && (this.jobid[0]['Value']!=undefined || this.jobid[0]['Value']!=null)?this.jobid[0]['Value']:'',
      "RouteId": this.selectedRoutGUID,
      "UserId": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    }
    this.ngxUiLoaderService.start();
    this.service.getvbdiagnostic(JSON.stringify(obj)).subscribe((data) => {
      if(data["status"]=="success"){
        let vburl=data["responsebody"];
        let params = `width=1000,height=500,left=250,top=150`;
        open(vburl, 'VBDiagnoistic', params);
      }
      this.ngxUiLoaderService.stop();
    }), error => {
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    };
  }
  viewmessages(routeid, inputstatus, dayFilter: 'today' | 'yesterday') {
    var data = {
      "id": routeid,
      "status": inputstatus.toLowerCase() == 'inprogress' ? 'In Progress' : inputstatus,
      "dayFilter": dayFilter
    };
    sessionStorage.setItem('hubmessagedata', JSON.stringify(data));
    this.service.setMessageObj(data);
  }


  openMapping(dataitem) {
    if (dataitem.id != '' && dataitem.PAID != '') {

      this.ngxUiLoaderService.start();
      var url = "api/GetMappings/Get?routeid=" + dataitem.id + "&processorid=" + dataitem.PAID + "&processorapikey=" + dataitem.PAAPIKEY;
      this.service.getapiurl(url).subscribe({
        next: async (responce) => {
          const sourceGuid = dataitem?.SEGUID || dataitem?.SourceAccountGuid || dataitem?.sourceGuid || '';
          const targetGuid = dataitem?.DEGUID || dataitem?.TargetAccountGuid || dataitem?.targetGuid || '';
          await this.ensureTestOrganizationFlagsLoaded(sourceGuid, targetGuid);

          this.Templatearray = responce as any[];
          this.dataToModal = {
            templateid: this.Templatearray["template"],
            templatelist: this.Templatearray["templatelist"],
            MappedXml: this.Templatearray["mappedxml"],
            resultJson: this.Templatearray["resultjson"],
            routeid: dataitem.id,
            processorid: dataitem.PAID,
            processorapikey: dataitem.PAAPIKEY,
            routeName: dataitem.displayname,
            ProcessorName: dataitem.PANAME,
            uniqueid: dataitem.UniqueID,
            routedetails: this.Templatearray["routeDetails"],
            CoreConfigVersionList: this.Templatearray["CoreConfigVersionList"],
            lockXMLmap: dataitem.IsLocked !== undefined && dataitem.IsLocked == "True" ? dataitem.IsLocked : false,
            componentname:'interface',
            ...this.getTestOrganizationFlagsForChildDialogs(),
          };

          if (this.Templatearray["mappedxml"] != null) {
            const xmlMappingModalRef = this.modalService.open(XmlmappingsComponent,
              { windowClass: "myCustomModalClasscreatexml", backdropClass: "xmlmappings-backdrop", backdrop: 'static', keyboard: false });
            xmlMappingModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
            this.trackModalRef(xmlMappingModalRef, "myCustomModalClasscreatexml");
            
            xmlMappingModalRef.result.then(
              (result) => {
                this.modalWasOpen = false;
                this.untrackModalRef(xmlMappingModalRef);
              },
              (reason) => {
                this.modalWasOpen = false;
                this.untrackModalRef(xmlMappingModalRef);
              }
            );
            
            // Add data attribute to identify the modal and backdrop
            setTimeout(() => {
              const modalElement = document.querySelector('.modal.show') as HTMLElement;
              if (modalElement) {
                modalElement.setAttribute('data-interface-modal', 'true');
              }
              const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
              if (backdrop) {
                backdrop.setAttribute('data-interface-modal', 'true');
              }
            }, 100);
            
            this.modalWasOpen = true;
          }
          else {
            this.modalService.dismissAll();
            this.toastr.error("Template configurations not found", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        },
        error: error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Unable to fetch the Mappings", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      });
    }
    else {
      this.toastr.error("Pipeline and Processor are mandatory", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

    //Tryitout modal start

    async opentryitout(dataitem) {
      if (dataitem.id != '' && dataitem.PAID != '') {
        this.ngxUiLoaderService.start();
        const response = await firstValueFrom(
          this.service.getapiurl(
            'api/CoreConfig/GetCoreConfigVersion?routeid=' + dataitem.id + '&agentid=' + dataitem.PAID + '&version='
          )
        );
        if (!response?.length) {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('No mapping version found.', '', { timeOut: 3500, positionClass: 'toast-bottom-right' });
          return;
        }
        const liveConfig = this.service.resolveLiveConfig(response);
        if (!liveConfig) {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('No live mapping version found for the route.', '', { timeOut: 3500, positionClass: 'toast-bottom-right' });
          return;
        }

        let enableAccessionSearch = false;
        if (dataitem.Direction === "Outbound") {
          enableAccessionSearch = true;
        }
        this.dataToModal = {
          RouteIdtry: dataitem.id,
          ProcessorIdtry: dataitem.PAID,
          Popupflag: true,
          PopupSource: 'interface',
          enableAccessionSearch: enableAccessionSearch,
          sourceagent: dataitem.sourceagentid || dataitem.SourceAgentid || "",
          sourceagentname: dataitem.sourceagentename || dataitem.sourceagentname || dataitem.SourceAgent || "",
          collectsourceagentflag: this.isCollectSourceAgent(dataitem),
        };
        const tryItOutModalRef = this.modalService.open(TryitoutComponent,
          { windowClass: "myCustomModalClassciisint", backdrop: 'static', keyboard: false });
  
        tryItOutModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
        this.trackModalRef(tryItOutModalRef, "myCustomModalClassciisint");
        
        tryItOutModalRef.result.then(
          (result) => {
            this.modalWasOpen = false;
            this.untrackModalRef(tryItOutModalRef);
          },
          (reason) => {
            this.modalWasOpen = false;
            this.untrackModalRef(tryItOutModalRef);
          }
        );
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
          const modalElement = document.querySelector('.modal.myCustomModalClassciisint') as HTMLElement;
          if (modalElement) {
            modalElement.setAttribute('data-interface-modal', 'true');
          }
          const backdrops = Array.from(document.querySelectorAll('.modal-backdrop.show')) as HTMLElement[];
          const backdrop = backdrops.length > 0 ? backdrops[backdrops.length - 1] : null;
          if (backdrop) {
            backdrop.setAttribute('data-interface-modal', 'true');
          }
        }, 100);
        
        this.modalWasOpen = true;
        this.ngxUiLoaderService.stop();
      }
      else {
        this.toastr.warning("Pipeline and Processor are mandatory", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
  
    }
    private isCollectSourceAgent(dataitem: any): boolean {
      const sourceAgentName = (
        dataitem?.sourceagentname ||
        dataitem?.SourceAgent ||
        dataitem?.SENAME ||
        ""
      ).toString().toLowerCase();
      const sourceAgent = (
        dataitem?.sourceagentid ||
        dataitem?.SourceAgentid ||
        ""
      ).toString().toLowerCase();
      return sourceAgentName.includes('collect') || sourceAgent.includes('collect');
    }
    editPipeline(item) {
      if (item.Version == '2') {
        sessionStorage.setItem('pipelineid', JSON.stringify(item.id));
        let obj={
          id:item.id,
          name:item.displayname
        }
        this.service.setPipelineName(JSON.stringify(obj));
      }
      else {
        const routeVersionModalRef = this.modalService.open(Routeversion1Component,
          { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
        routeVersionModalRef.componentInstance.inputDataInModalComponent = item;
        this.trackModalRef(routeVersionModalRef, "myCustomModalClass");
        
        routeVersionModalRef.result.then(
          (data) => {
            this.isChecked = false;
            if (data == 'save') { this.search(false, true); }
            this.modalWasOpen = false;
            this.untrackModalRef(routeVersionModalRef);
          },
          (reason) => {
            this.modalWasOpen = false;
            this.untrackModalRef(routeVersionModalRef);
          }
        );
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
          const modalElement = document.querySelector('.modal.show') as HTMLElement;
          if (modalElement) {
            modalElement.setAttribute('data-interface-modal', 'true');
          }
          const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
          if (backdrop) {
            backdrop.setAttribute('data-interface-modal', 'true');
          }
        }, 100);
        
        this.modalWasOpen = true;
      }
    }

    openassignusermodal(modal, obj) {
      if (this.pagerolepermisions.assignuser) {
        this.pipelineObj = '';
        this.pipelineObj = obj;
        if (this.pipelineObj.assignedUserId) {
          this.selecteduserid = this.pipelineObj.assignedUserId;
          this.isftpuser = true;
  
          this.selectedusername = this.pipelineObj.MODIFIERID;
          this.reactiveFormuser.patchValue({
            user: this.selectedusername
          })
        }
      }
      const assignUserModalRef = this.modalService.open(modal,
        { windowClass: "assignuser", backdrop: 'static', keyboard: false });
      this.trackModalRef(assignUserModalRef, "assignuser");
      
      assignUserModalRef.result.then(
        (result) => {
          this.modalWasOpen = false;
          this.untrackModalRef(assignUserModalRef);
        },
        (reason) => {
          this.modalWasOpen = false;
          this.untrackModalRef(assignUserModalRef);
        }
      );
      
      // Add data attribute to identify the modal and backdrop
      setTimeout(() => {
        const modalElement = document.querySelector('.modal.show') as HTMLElement;
        if (modalElement) {
          modalElement.setAttribute('data-interface-modal', 'true');
        }
        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
        if (backdrop) {
          backdrop.setAttribute('data-interface-modal', 'true');
        }
      }, 100);
      
      this.modalWasOpen = true;
    }

    getuserdetails() {
      var url = "api/UserRoleConfig/GetInterfaceAssignUsers?userid=" + JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
      this.service.getapiurl(url).subscribe(data => {
        if (data) {
          this.userlist = data as any[];
          this.userlistbackup = this.userlist;
        }
      });
    }
    assignuser(c) {
  
      let interfacearray = <any>[];
      interfacearray.push(this.pipelineObj.displayname);
      if (this.selecteduserid) {
        if (this.pipelineObj.assignedUserId != this.selecteduserid) {
          this.ngxUiLoaderService.start();
          let obj = {
            userid: this.selecteduserid,
            username: this.selectedusername,
            modifiedby: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
            routeuniqueid: this.pipelineObj.UniqueID,
            pipelines: interfacearray,
            isFtpAvailableForUser: this.isftpuser
          }
          let url = "api/Routes/AssignUserToInterface";
          this.service.postapi(url, obj).then(data => {
            if (data) {
              this.ngxUiLoaderService.stop();
              if ((data['status'] && data['statusText']) || data['statusText'] === "Unknown Error") {
                this.ngxUiLoaderService.stop();
                this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
              }
              else {
                if (data.status.toLowerCase() == "success") {
                  let displaymessage = '';
                  displaymessage = 'Pipeline has been assign to ' + this.selectedusername;
  
                  this.service.auditsave("Add", '', displaymessage, "Pipeline", this.pipelineObj.UniqueID,'Pipeline has been assigned Successfully').then(data => {
                    if (data['status'] && data['statusText']) {
                      this.toastr.error("Unable to Audit the transaction", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                      });
                    }
                  })
  
                  this.toastr.success(data.statusmessage, "", { timeOut: 500, positionClass: 'toast-bottom-right' });
                  this.search(false, true);
                  this.closeusermodal(c);
                }
                else {
                  this.service.copyableToastError(data.statusmessage);
                }
              }
            }
          })
        }
        else {
          this.toastr.warning("User already assigned", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      }
      else {
        this.toastr.warning("Please select the valid user", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
  
    }
    closeusermodal(c) {
      this.resetuserdetails();
      c('close modal');
    }
    resetuserdetails() {
      this.userlist = this.userlistbackup;
      this.reactiveFormuser.reset();
      this.selecteduserid = '';
      this.selectedusername = '';
      this.isftpuser = false;
      this.isLoadinguser = false;
    }
    selecteduser(event) {
      this.selecteduserid = event.UserId;
      this.selectedusername = event.UserName;
      this.isftpuser = event.IsFtpAvailableForUser;
    }
    searchuserCleared() {
      this.selecteduserid = '';
      this.isftpuser = false;
      this.userlist = this.userlistbackup;
      this.reactiveFormuser.setValue({ "user": '' });
    }
  
    getuserName(event) {
      this.isLoadinguser = false;
      this.selecteduserid = '';
      if (this.userlist.length > 0) {
        this.filteruserlist(event);
      }
      else {
        this.userlist = this.userlistbackup;
        this.filteruserlist(event);
      }
    }
    filteruserlist(event) {
      this.userlist = this.userlist.filter(t => t.UserName.toLowerCase().includes(event.toLowerCase()));
      if (this.userlist.length == 0) {
  
        this.notfounddata = true;
  
      } else {
        this.notfounddata = false;
      }
      this.isLoadinguser = false;
    }
    showExtendedPipelineMenu(intlist: any): boolean {
      const contentType = (intlist?.ProcessorContentType || '').toLowerCase();
      const messageType = (intlist?.messagetype || '').toLowerCase();
      return intlist?.PATYPE == 'General'
        || contentType == 'hl7'
        || ((contentType == 'json' || contentType == 'xml') && messageType !== 'adt');
    }

    async toggleRouteVisibility(intlist: any, event: Event) {
      event.stopPropagation();
      const newIsHidden = !intlist['IsHidden'];
      try {
        const data = await this.service.postapi('api/Routes/UpdateRouteVisibility', {
          UniqueId: intlist['UniqueID'],
          IsHidden: newIsHidden
        });
        if ((data['status'] && data['statusText']) || data['statusText'] === 'Unknown Error') {
          this.toastr.error('Unable to update pipeline visibility', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        } else if (data?.status?.toLowerCase() === 'success') {
          intlist['IsHidden'] = newIsHidden;
          const auditMessage = newIsHidden ? 'pipeline hidden Successfully' : 'pipeline shown Successfully';
          this.service.auditsave('Update', '', auditMessage, 'Pipeline', intlist['UniqueID'], auditMessage).then(auditData => {
            if (auditData['status'] && auditData['statusText']) {
              this.toastr.error('Unable to Audit the transaction', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            }
          });
          this.toastr.success(data.statusmessage, '', {
            timeOut: 500,
            positionClass: 'toast-bottom-right'
          });
        } else {
          this.service.copyableToastError(data?.statusmessage || 'Unable to update pipeline visibility');
        }
      } catch {
        this.toastr.error('Unable to update pipeline visibility', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }

    openHL7Viewer(intlist: any) {
      if (intlist.id != '' && intlist.PAID != '') {
        const hl7ViewerModalRef = this.modalService.open(Hl7viewerComponent, {
          size: 'xl',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'modal-fullscreen'
        });
        
        // Pass interface data to the HL7 viewer
        hl7ViewerModalRef.componentInstance.interfaceId = intlist.id;
        hl7ViewerModalRef.componentInstance.processorAgentId = intlist.PAID;
        hl7ViewerModalRef.componentInstance.isFromInterface = true;
        this.trackModalRef(hl7ViewerModalRef, "modal-fullscreen");
        
        hl7ViewerModalRef.result.then(
          (result) => {
            this.modalWasOpen = false;
            this.untrackModalRef(hl7ViewerModalRef);
          },
          (reason) => {
            this.modalWasOpen = false;
            this.untrackModalRef(hl7ViewerModalRef);
          }
        );
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
          const modalElement = document.querySelector('.modal.show') as HTMLElement;
          if (modalElement) {
            modalElement.setAttribute('data-interface-modal', 'true');
          }
          const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
          if (backdrop) {
            backdrop.setAttribute('data-interface-modal', 'true');
          }
        }, 100);
        
        this.modalWasOpen = true;
      }
    }

    async openValidationMapping(dataitem: any): Promise<void> {
      if (!dataitem?.id || !dataitem?.PAID) {
        this.toastr.error('Pipeline and Processor are mandatory', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }

      try {
        this.ngxUiLoaderService.start();
        const uniqueId = dataitem.UniqueID;
        const raw = await this._ruleEngineService.GetRuleConfigVersions(uniqueId, 'PreValidation').toPromise();
        const list = Array.isArray(raw) ? raw : [];

        if (list.length > 0) {
          this.ngxUiLoaderService.stop();
          await this.openPreValidationRuleConfig(dataitem);
          return;
        }

        const url = 'api/GetMappings/Get?routeid=' + dataitem.id + '&processorid=' + dataitem.PAID
          + '&processorapikey=' + dataitem.PAAPIKEY + '&prevalidation=true';
        const response = await this.service.getapiurl(url).toPromise();
        this.ngxUiLoaderService.stop();

        if (this.hasLegacyValidationConfig(response)) {
          this.openLegacyValidationMappingModal(dataitem, response);
        } else {
          await this.openPreValidationRuleConfig(dataitem);
        }
      } catch {
        this.ngxUiLoaderService.stop();
        this.toastr.error('Unable to fetch the Validation Mappings', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }
    clearInput(inputElement: HTMLInputElement): void {
      this.showSuggestions = false;
      this.reactiveFormroute.patchValue({ routename: '' });
      this.searchRouteNameCleared(null);
      this.selectedGS = '';
    }

    clearPipelineRouteSearch(): void {
      this.reactiveFormroute.patchValue({ routename: '' });
      this.searchRouteNameCleared(null);
    }

    getCurrentRouteSearchValue(): string {
      const value = this.reactiveFormroute.get('routename')?.value;
      if (value == null || value === '') {
        return '';
      }
      if (typeof value === 'string') {
        return value;
      }
      if (typeof value === 'object' && value[this.keywordsearch]) {
        return value[this.keywordsearch];
      }
      return String(value);
    }

    syncRouteSearchCacheFromInput(searchValue?: string): void {
      const trimmed = (searchValue ?? this.getCurrentRouteSearchValue()).trim();
      if (!trimmed) {
        this.selectedGS = '';
        this.selectedrouteId = '';
        this.selectedrouteDisplayName = '';
      }
    }

    onGlobalSearchClick(): void {
      const searchValue = this.getCurrentRouteSearchValue().trim();
      this.syncRouteSearchCacheFromInput(searchValue);
      this.onSearch(searchValue, 1, false);
    }

    onPipelineSearchClick(): void {
      const searchValue = this.getCurrentRouteSearchValue().trim();
      this.syncRouteSearchCacheFromInput(searchValue);
      this.getpipelinelist(true, false);
    }

    setupSearch(): void {
      this.reactiveFormroute.get('routename')?.valueChanges
      .pipe(
        startWith(''), 
        distinctUntilChanged(),
        switchMap((searchTerm: string) => {
          const trimmed = (searchTerm || '').trim();
          if (!trimmed) {
            this.syncRouteSearchCacheFromInput('');
            return of(searchTerm); 
          }
          return timer(1400).pipe(map(() => searchTerm)); 
        })
      )
        .subscribe((searchTerm: string) => {
          const trimmed = (searchTerm || '').trim();
          if (trimmed && this.global) {
            this.showSuggestions = true;
            this.CallBySearchBar = true;
            this.onSearch(trimmed, 1, true);
          }
        });
    }



    onSearch(value: string,pagenumber,triggeredBySearchBar: boolean): void {

      // This checks if the quotes correctly entered or not if not then the request will not go to API
      if (!this.validateQuotes(value) && triggeredBySearchBar) {
        return;
      }
      this.CallBySearchBar=triggeredBySearchBar;
      let routeStatus=this.status ? "active" : "passive";
      this.CallBySearchBar?routeStatus=routeStatus:'';
      this.selectedGS = (value === undefined || value === null || value === "") ? "" : value.trim();
      const assignedUserId = this.isChecked ? JSON.parse(sessionStorage.getItem('rolewithmenus'))[0].uniqueId : '';
      const userType = this.isChecked ? '2' : '';
      
      //if (value != null && value.length > 3) {
        this.isLoadingGS = !this.global;
      this.ngxUiLoaderService.start();
      this.interfacedetails = []
      if (this.fromdate != '' && this.todate == '') {
        this.toastr.warning("Unable to search", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.ngxUiLoaderService.stop();
        // Close pinned messages
        this.expandedIds.clear();
      }  
else{
        // Construct the API URL based on the 'global' flag
        const url = this.global
          ? `api/Routes/GetByInterfaceDetail?name=${this.selectedGS}&version=0&global=${this.global}&pagenumber=${pagenumber}&status=${routeStatus}&assignedUserId=${assignedUserId}&callBySearchBar=${this.CallBySearchBar}`
          : `api/Routes/GetByInterfaceDetail?name=${this.selectedGS}&version=0`;
  
        // Fetch data from API
        this.service.getapiurl(url).subscribe({
          next: (data) => {
           
            if (data.length == 0) {
              this.ngxUiLoaderService.stop();
	      if(this.global){
	       this.toastr.error("No data found", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
	     this.interfacelist = []
          this.totalrecords = 0
          this.paginator.firstPage();
          // Close pinned messages
          this.expandedIds.clear();
          this.pinnedMessageCountByRouteId = {};
	  }
	  else{
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
	  this.notfounddata = false;
              this.isLoadingGS = false;
          // Close pinned messages
          this.expandedIds.clear();
	      
	      }
            } 
            else {
              this.ngxUiLoaderService.stop();
		if(this.global){
		this.interfacelist = []
          this.interfacelist = data as any[]
          this.totalrecords = parseInt(data[0].totalpipelinecount.toString());
          if (this.pagenumber > 0 && this.paginator != undefined) {
            this.paginator.length = this.totalrecords;
          }
          // Close pinned messages
          this.expandedIds.clear();
          this.loadPinnedMessageCountsForInterfaceList(this.interfacelist);
	  }
	 
	 
            }
           
          },
          error: (error) => {
            this.ngxUiLoaderService.stop();
            
            this.toastr.error('No result found', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            // Close pinned messages
            this.expandedIds.clear();
	    
          },
        });
      } 
   
    }
updatefilecount(obj){
this.pendingfilecount=obj['pendingfilecount'];
this.pendingfiledate=obj['pendingfiledate'];
}
validateQuotes(searchText: string): boolean {
    if (typeof searchText !== 'string' || searchText === undefined || searchText === null) {
      // Treat undefined/null/empty as valid (no quotes to check)
      return true;
    }
    const quoteCount = (searchText.match(/"/g) || []).length;
    if (quoteCount % 2 !== 0) {
      this.toastr.warning('Quotes are not correctly entered.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    // Find all quoted segments
    const quotedSegments = searchText.match(/"([^"]*)"/g) || [];
    for (const segment of quotedSegments) {
      // Remove the quotes and check if empty or whitespace
      const inner = segment.slice(1, -1);
      if (inner.trim() === '') {
        this.toastr.warning('Empty quotes are not allowed. Please enter text between quotes.', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }
    }
    return true;
  }

  hideModals() {
    // Only hide if we have open modals tracked in currentModalRefs
    if (this.currentModalRefs && this.currentModalRefs.length > 0 && this.modalRefsTracked && this.modalRefsTracked.length > 0) {
      // Get only the windowClasses that THIS component opened
      const ownedModalClasses = this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '');
      
      if (ownedModalClasses.length === 0) {
        this.modalWasOpen = false;
        return; // No modals owned by this component
      }
      
      // Find ALL interface modals by windowClass - only search for classes THIS component owns
      const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
      let modalElements = Array.from(document.querySelectorAll(selector)) as HTMLElement[];
      
      // If not found by windowClass, find any visible modal with classes THIS component owns
      if (modalElements.length === 0) {
        const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
        modalElements = allModals.filter(modal => {
          const style = window.getComputedStyle(modal);
          const hasOwnedClass = ownedModalClasses.some(className => modal.classList.contains(className));
          // Check if modal is visible and has one of the classes THIS component owns
          return hasOwnedClass && (modal.classList.contains('show') || (style.display !== 'none' && style.display !== ''));
        });
      }
      
      if (modalElements.length > 0) {
        this.modalWasOpen = true;

        // Hide ALL modals that belong to THIS component
        modalElements.forEach(modalElement => {
          const style = window.getComputedStyle(modalElement);
          // Only hide if it's actually visible
          if (modalElement.classList.contains('show') || (style.display !== 'none' && style.display !== '')) {
            // Hide the modal visually but keep it in DOM - use !important via setProperty
            modalElement.style.setProperty('display', 'none', 'important');
            // Remove show class to prevent Bootstrap from showing it
            modalElement.classList.remove('show');
          }
        });
        
        // Also hide all backdrops
        const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        allBackdrops.forEach(backdrop => {
          const backdropStyle = window.getComputedStyle(backdrop);
          if (backdropStyle.display !== 'none' && !backdrop.hasAttribute('data-create-modal')) {
            backdrop.style.setProperty('display', 'none', 'important');
            backdrop.classList.remove('show');
          }
        });
        
        // Also hide nested hl7viewer modals inside ftpfiles (nested modal scenario)
        let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
        // Fallback to class name if data attribute not found
        if (nestedHl7Modals.length === 0) {
          nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
        }
        nestedHl7Modals.forEach(nestedModal => {
          const nestedStyle = window.getComputedStyle(nestedModal);
          // Only hide if it's visible and not already marked as interface-modal
          if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
              !nestedModal.hasAttribute('data-interface-modal')) {
            nestedModal.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
            nestedModal.style.setProperty('display', 'none', 'important');
            // Keep 'show' class to prevent dismissal
          }
        });
        
        // Also hide nested hl7viewer modal backdrops
        const nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        nestedHl7Backdrops.forEach(nestedBackdrop => {
          const backdropStyle = window.getComputedStyle(nestedBackdrop);
          // Hide if visible and not already marked as interface-modal (to avoid double-hiding)
          if (backdropStyle.display !== 'none' && !nestedBackdrop.hasAttribute('data-interface-modal') && !nestedBackdrop.hasAttribute('data-create-modal')) {
            nestedBackdrop.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
            nestedBackdrop.style.setProperty('display', 'none', 'important');
          }
        });
        
        // Also remove modal-open class from body to prevent scroll issues
        document.body.classList.remove('modal-open');
      } else {
        // No modal found but we have tracked refs - keep modalWasOpen true if we have tracked modals
        this.modalWasOpen = this.currentModalRefs.length > 0;
      }
    } else {
      // No tracked modals - nothing to hide
      this.modalWasOpen = false;
    }
  }

  showModals() {
    // Only show if modal was open when tab became inactive
    if (this.modalWasOpen) {
      // Use a small delay to ensure DOM is ready
      setTimeout(() => {
        // Get only the windowClasses that THIS component opened
        const ownedModalClasses = this.modalRefsTracked && this.modalRefsTracked.length > 0 
          ? this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '')
          : [];
        
        if (ownedModalClasses.length === 0) {
          this.modalWasOpen = false;
          return; // No modals owned by this component
        }
        
        // Find ALL interface modals by windowClass - only search for classes THIS component owns
        const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
        let modalElements = Array.from(document.querySelectorAll(selector)) as HTMLElement[];
        
        // If not found by windowClass, find any hidden modal with classes THIS component owns
        if (modalElements.length === 0) {
          const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
          modalElements = allModals.filter(modal => {
            const style = window.getComputedStyle(modal);
            const hasOwnedClass = ownedModalClasses.some(className => modal.classList.contains(className));
            // Find modal with owned class that is hidden (display: none) or doesn't have show class
            return hasOwnedClass && (style.display === 'none' || !modal.classList.contains('show'));
          });
        }
        
        // Only show if we still have tracked modals (they weren't closed)
        if (modalElements.length > 0 && this.currentModalRefs && this.currentModalRefs.length > 0) {
          // Show ALL modals that belong to THIS component
          modalElements.forEach(modalElement => {
            const style = window.getComputedStyle(modalElement);
            // Only show if it has one of the classes THIS component owns
            const hasOwnedClass = ownedModalClasses.some(className => modalElement.classList.contains(className));
            // Only show if it was hidden (display: none) and belongs to this component
            if (hasOwnedClass && (style.display === 'none' || !modalElement.classList.contains('show'))) {
              // Show the modal again - override !important by setting with !important
              modalElement.style.setProperty('display', 'block', 'important');
              if (!modalElement.classList.contains('show')) {
                modalElement.classList.add('show');
              }
            }
          });
          
          // Show all backdrops that were hidden (prefer those marked with data attribute)
          let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-interface-modal="true"]')) as HTMLElement[];
          
          backdrops.forEach(backdrop => {
            const backdropStyle = window.getComputedStyle(backdrop);
            if (backdropStyle.display === 'none') {
              backdrop.style.setProperty('display', 'block', 'important');
              if (!backdrop.classList.contains('show')) {
                backdrop.classList.add('show');
              }
            }
          });
          
          // If no backdrop found, ensure body has modal-open class so Bootstrap can create it
          if (backdrops.length === 0) {
            document.body.classList.add('modal-open');
          }
          
          // Also show nested hl7viewer modals inside ftpfiles if they were open (nested modal scenario)
          let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
          // Fallback to class name if data attribute not found
          if (nestedHl7Modals.length === 0) {
            nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
          }
          nestedHl7Modals.forEach(nestedModal => {
            const nestedStyle = window.getComputedStyle(nestedModal);
            // Show if it was hidden (display: none) - meaning it was open before
            if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                !nestedModal.hasAttribute('data-interface-modal')) {
              nestedModal.style.setProperty('display', 'block', 'important');
              if (!nestedModal.classList.contains('show')) {
                nestedModal.classList.add('show');
              }
            }
          });
          
          // Also show nested hl7viewer modal backdrops
          let nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-ftpfiles-hl7viewer-modal="true"]')) as HTMLElement[];
          // If no backdrops found by data attribute, find all backdrops that aren't marked as interface-modal
          if (nestedHl7Backdrops.length === 0) {
            const allBackdropsForNested = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
            nestedHl7Backdrops = allBackdropsForNested.filter(backdrop => !backdrop.hasAttribute('data-interface-modal') && !backdrop.hasAttribute('data-create-modal'));
          }
          nestedHl7Backdrops.forEach(nestedBackdrop => {
            const backdropStyle = window.getComputedStyle(nestedBackdrop);
            if (backdropStyle.display === 'none') {
              nestedBackdrop.style.setProperty('display', 'block', 'important');
              if (!nestedBackdrop.classList.contains('show')) {
                nestedBackdrop.classList.add('show');
              }
            }
          });
          
          // Re-add modal-open class to body
          document.body.classList.add('modal-open');
        } else {
          this.modalWasOpen = false;
        }
      }, 0);
    }
  }

  togglePinnedExpand() {
    this.showPinned = !this.showPinned;
  }

  toggleExpand(id: string, event: MouseEvent) {
    event.stopPropagation();
    // Redirect to messages screen with pinned filter pre-selected
    const data = {
      "id": id,
      "pinnedonly": true
    };
    sessionStorage.setItem('hubmessagedata', JSON.stringify(data));
    this.service.setMessageObj(data);
  }

  isExpanded(id: string): boolean {
    return this.expandedIds.has(id);
  }

  getChildMessages(parentId: string) {
    return this.childMessages.filter(x => x.parentId === parentId);
  }

  // Helper method to get entitySearch data from pinned message
  getEntitySearchData(child: any): any[] {
    if (!child) return [];
    // Check for both possible property names (case variations)
    const entitySearch = child.entitySearch || child.entitysearch || child.EntitySearch || [];
    return Array.isArray(entitySearch) ? entitySearch : [];
  }

  // Helper method to get Searchkey from entity
  getSearchKey(entity: any): string {
    if (!entity) return '';
    return entity.Searchkey || entity.searchkey || entity.SearchKey || entity.searchKey || '';
  }

  // Helper method to get SearchValue from entity
  getSearchValue(entity: any): string {
    if (!entity) return '';
    return entity.SearchValue || entity.searchvalue || entity.searchValue || '';
  }

  // Check if searchkey is copyable (includes 'access' or 'req')
  isCopyableSearchKey(searchKey: string): boolean {
    if (!searchKey) return false;
    const key = searchKey.toLowerCase();
    return key.includes('access') || key.includes('req');
  }

  getUserIdFromSession(): string {
    try {
      const sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
      return sessionObject?.userdata?.['userid'] || '';
    } catch (e) {
      return '';
    }
  }

  openAuditPopUp(id:any,username:any) {
  
      if (id != '' && username!='') {
        const auditDataToModal = {
          id:id,
          title:username ,
          context: "interface",
          type: "ID",
          userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
        };
  
        const modalRef = this.modalService.open(NewauditComponent,
          { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
        this.trackModalRef(modalRef, "myCustomModalClass");
        modalRef.result.then(() => {
          this.untrackModalRef(modalRef);
        }, (reason) => {
          this.untrackModalRef(modalRef);
        });
      }
  
  }

  getAllTheCache(routeGuid: string) {
    const obj = {
    pageNumber: 1,
    pageSize: 100,
    keysearch: routeGuid
  };

  this.ngxUiLoaderService.start();
  this._ruleEngineService.getCoreCache(obj).subscribe({
    next: (data) => {
      if (data.length > 0) {
        data.forEach((V, index) => {
          let obj = {};
          obj['key'] = V["key"];
          this.totalrecords = V["count"];
          this.ngxUiLoaderService.stop();
          this.cacheList.push(obj);
        });
        this.clearCache();
      } else {
        this.ngxUiLoaderService.stop();
        this.cacheList = [];
      }
    },

    error: () => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Error Occurred", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.cacheList = [];
    }
  });
}
  clearCache(){
    let finalString='';
    this.cacheList.forEach(V=>{
      finalString+=V['key']+',';
    });
    this.ngxUiLoaderService.start();
    const keysToDelete = this.cacheList.map(V => V['key']);
    this._ruleEngineService.getClearCache(keysToDelete).subscribe(
      data => {
        this.ngxUiLoaderService.stop();
      },
      error => {
        this.ngxUiLoaderService.stop();
      }
    );
  }
  /** Same Look Ups experience as Mapping screen (InterfacemappingComponent). */
openLookupsModal(data:any): void {
  const pd: any = data;
  if (!pd || !pd['id'] || pd['UniqueID'] === undefined || pd['UniqueID'] === null || pd['UniqueID'] === '') {
    this.toastr.warning('Select an interface to manage lookups.', '', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return;
  }
  const dataToModal = {
    routeid: pd['id'],
    routename: pd['displayname'] || pd['DisplayName'] || '',
    uniqueid: pd['UniqueID'],
    templateid: '',
    templatename: '',
    LockInterfaceUpload: pd['IsLocked'] !== undefined && String(pd['IsLocked']).toLowerCase() === 'true'
  };
  const modalRef = this.modalService.open(InterfacemappingComponent, {
    windowClass: 'myCustomModalClasslookup',
    backdrop: 'static',
    keyboard: false
  });
  modalRef.componentInstance.inputDataInModalComponent = dataToModal;
  this.trackModalRef(modalRef, 'myCustomModalClasslookup');
  modalRef.result.then(
    () => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    },
    () => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    }
  );
  setTimeout(() => {
    const modalElement = document.querySelector('.modal.show') as HTMLElement;
    if (modalElement) {
      modalElement.setAttribute('data-interface-modal', 'true');
    }
    const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
    if (backdrop) {
      backdrop.setAttribute('data-interface-modal', 'true');
    }
  }, 100);
  this.modalWasOpen = true;
  }

  closeInterfaceMenu(menuTrigger: MatMenuTrigger): void {
    menuTrigger?.closeMenu();
    (document.activeElement as HTMLElement | null)?.blur?.();
  }

  onCompareClick(intlist: any): void {
    if (!intlist?.id || !intlist?.PAID) {
      this.toastr.error('Pipeline and Processor are mandatory', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    if (!this.compareSourceInterface) {
      this.compareSourceInterface = intlist;
      return;
    }

    if (this.compareSourceInterface.id === intlist.id) {
      this.toastr.warning('Select a different interface to compare.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    setTimeout(() => {
      this.openInterfaceCompareModal(this.compareSourceInterface, intlist);
    }, 0);
  }

  clearCompareSource(): void {
    this.compareSourceInterface = null;
  }

  openInterfaceCompareModal(left: any, right: any): void {
    (document.activeElement as HTMLElement | null)?.blur?.();
    const compareModalRef = this.modalService.open(InterfaceCompareComponent, {
      windowClass: 'myCustomModalClassInterfaceCompare',
      backdropClass: 'xmlmappings-backdrop',
      backdrop: 'static',
      keyboard: false,
    });
    compareModalRef.componentInstance.inputDataInModalComponent = { left, right };
    this.trackModalRef(compareModalRef, 'myCustomModalClassInterfaceCompare');

    compareModalRef.result.then(
      () => {
        this.modalWasOpen = false;
        this.untrackModalRef(compareModalRef);
      },
      () => {
        this.modalWasOpen = false;
        this.untrackModalRef(compareModalRef);
      },
    );

    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-interface-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-interface-modal', 'true');
      }
    }, 100);

    this.modalWasOpen = true;
  }
}
